(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X$": function() { return /* binding */ SearchProvider; },
  "bn": function() { return /* binding */ useSearchDispatch; },
  "XN": function() { return /* binding */ useSearchState; }
});

// UNUSED EXPORTS: defaultSearchState

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/interfaces/context/searchContextInterfaces.ts
var searchContextInterfaces = __webpack_require__(8619);
;// CONCATENATED MODULE: ./src/reducers/locationReducer.ts

const defaultLocation = {
    label: "",
    latitude: null,
    longitude: null,
    value: "",
    remote_work_location_type: null
};
const defaultState = {
    userInputValue: "",
    userSelectedLocation: defaultLocation,
    locationSuggestions: []
};
/**
* A context reducer taking in a state and action, which in turn updates the context.
*/ const locationReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* LocationActionTypes.updateLocation */.B3.updateLocation:
            {
                let userInputValue = action.payload?.userInputValue === "" ? "" : action.payload.userInputValue;
                let userSelectedLocation = action.payload?.userSelectedLocation || defaultLocation;
                if (action.payload?.userInputValue === "Flexible / Remote") {
                    userInputValue = "Remote / Flexible";
                }
                if (action.payload?.userSelectedLocation?.value === "Flexible / Remote") {
                    userSelectedLocation = {
                        label: "Remote / Flexible",
                        latitude: null,
                        longitude: null,
                        value: "Remote / Flexible",
                        remote_work_location_type: "virtual"
                    };
                }
                return {
                    ...state,
                    userInputValue,
                    userSelectedLocation
                };
            }
        case searchContextInterfaces/* LocationActionTypes.updateLocationSuggestions */.B3.updateLocationSuggestions:
            {
                const updatedState = {
                    ...state,
                    locationSuggestions: action.payload.locationSuggestions
                };
                return updatedState;
            }
        case searchContextInterfaces/* LocationActionTypes.resetLocation */.B3.resetLocation:
            {
                return defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/companyReducer.ts

const companyReducer_defaultState = {
    userInputValue: "",
    userSelectedCompany: null,
    companySuggestions: []
};
const companyReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* CompanyActionTypes.updateCompany */.iW.updateCompany:
            {
                const updatedState = {
                    ...state,
                    userInputValue: action.payload.userInputValue === null ? "" : action.payload.userInputValue,
                    userSelectedCompany: action.payload.userSelectedCompany
                };
                return updatedState;
            }
        case searchContextInterfaces/* CompanyActionTypes.updateCompanySuggestions */.iW.updateCompanySuggestions:
            {
                const updatedState1 = {
                    ...state,
                    companySuggestions: action.payload.companySuggestions
                };
                return updatedState1;
            }
        case searchContextInterfaces/* CompanyActionTypes.resetCompany */.iW.resetCompany:
            {
                return companyReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/keywordReducer.ts

const keywordReducer_defaultState = {
    userInputValue: "",
    userSelectedKeyword: null
};
const keywordReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* KeywordActionTypes.updateKeyword */.l0.updateKeyword:
            {
                const updatedState = {
                    ...state,
                    ...action.payload
                };
                return updatedState;
            }
        case searchContextInterfaces/* KeywordActionTypes.resetKeyword */.l0.resetKeyword:
            {
                return keywordReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/filtersReducer.ts

const filtersReducer_defaultState = {
    category: [],
    industry: [],
    experienceLevel: [],
    perks: [],
    companySize: [],
    radius: "",
    postedDateRange: "",
    companyLeadership: []
};
const filtersReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter:
            {
                const updatedState = {
                    ...state,
                    ...action.payload
                };
                return updatedState;
            }
        case searchContextInterfaces/* FiltersActionTypes.resetAllFilters */.bL.resetAllFilters:
            {
                return filtersReducer_defaultState;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/userInteractionsReducer.ts

const userInteractionsReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* UserInteractionActionTypes.updateJobTileViews */.lj.updateJobTileViews:
            {
                const updatedState = {
                    ...state,
                    tilesViewedJobIds: [
                        ...state.tilesViewedJobIds,
                        ...action.payload.tilesViewedJobIds
                    ]
                };
                return updatedState;
            }
        case searchContextInterfaces/* UserInteractionActionTypes.resetJobTileViews */.lj.resetJobTileViews:
            {
                const updatedState1 = {
                    ...state,
                    tilesViewedJobIds: []
                };
                return updatedState1;
            }
        case searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction:
            {
                const updatedState2 = {
                    ...state,
                    ...action.payload
                };
                return updatedState2;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/urlReducer.ts

const urlReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* UrlActionTypes.updateUrl */.qB.updateUrl:
            {
                return action.payload;
            }
        default:
            {
                return state;
            }
    }
};

;// CONCATENATED MODULE: ./src/reducers/searchIdReducer.ts

const searchIdReducer = (state, action)=>{
    switch(action.type){
        case searchContextInterfaces/* SearchIdActionTypes.updateSearchId */._L.updateSearchId:
            return action.payload;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/utils/reducers.ts
var reducers = __webpack_require__(5823);
;// CONCATENATED MODULE: ./src/hooks/SearchContext.tsx










const defaultSearchState = {
    location: {
        userInputValue: "",
        userSelectedLocation: {
            label: "",
            latitude: null,
            longitude: null,
            value: "",
            remote_work_location_type: null
        },
        locationSuggestions: []
    },
    company: {
        userInputValue: "",
        userSelectedCompany: null,
        companySuggestions: []
    },
    keyword: {
        userInputValue: "",
        userSelectedKeyword: null
    },
    filters: {
        category: [],
        industry: [],
        experienceLevel: [],
        perks: [],
        companySize: [],
        companyLeadership: []
    },
    userInteractions: {
        tilesViewedJobIds: []
    },
    url: "",
    preference: "",
    searchId: "",
    ctsEnabled: false
};
const SearchStateContext = /*#__PURE__*/ react.createContext(defaultSearchState);
const SearchDispatchContext = /*#__PURE__*/ react.createContext(undefined);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchProvider>
 *   <Component />
 * </SearchProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useSearchDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ const SearchProvider = (props)=>{
    const { children , location , company , keyword , filters , userInteractions , preference , searchId , ctsEnabled  } = props;
    const [state, dispatch] = (0,reducers/* useCombinedReducers */.F)({
        location: react.useReducer(locationReducer, {
            ...defaultSearchState.location,
            ...location
        }),
        company: react.useReducer(companyReducer, {
            ...defaultSearchState.company,
            ...company
        }),
        keyword: react.useReducer(keywordReducer, {
            ...defaultSearchState.keyword,
            ...keyword
        }),
        filters: react.useReducer(filtersReducer, {
            ...defaultSearchState.filters,
            ...filters
        }),
        userInteractions: react.useReducer(userInteractionsReducer, {
            ...defaultSearchState.userInteractions,
            ...userInteractions
        }),
        url: react.useReducer(urlReducer, defaultSearchState.url),
        searchId: react.useReducer(searchIdReducer, searchId)
    });
    const searchState = (0,react.useMemo)(()=>({
            ...state,
            preference: preference ?? defaultSearchState.preference,
            ctsEnabled: ctsEnabled === true
        }), [
        state,
        preference,
        ctsEnabled
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchStateContext.Provider, {
        value: searchState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const useSearchState = ()=>{
    const context = react.useContext(SearchStateContext);
    if (context === undefined) {
        throw new Error("useSearchState must be used within the SearchProvider");
    }
    return context;
};
const useSearchDispatch = ()=>{
    const context = react.useContext(SearchDispatchContext);
    if (context === undefined) {
        throw new Error("useSearchDispatch must be used within the SearchProvider");
    }
    return context;
};
SearchProvider.displayName = "SearchProvider";
useSearchState.displayName = "useSearchState";
useSearchDispatch.displayName = "useSearchDispatch";



/***/ }),

/***/ 8619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B3": function() { return /* binding */ LocationActionTypes; },
/* harmony export */   "_L": function() { return /* binding */ SearchIdActionTypes; },
/* harmony export */   "bL": function() { return /* binding */ FiltersActionTypes; },
/* harmony export */   "iW": function() { return /* binding */ CompanyActionTypes; },
/* harmony export */   "l0": function() { return /* binding */ KeywordActionTypes; },
/* harmony export */   "lj": function() { return /* binding */ UserInteractionActionTypes; },
/* harmony export */   "qB": function() { return /* binding */ UrlActionTypes; }
/* harmony export */ });
/* unused harmony export WindowLocationActionTypes */
var LocationActionTypes;
(function(LocationActionTypes) {
    LocationActionTypes["updateLocation"] = "update_location";
    LocationActionTypes["updateLocationSuggestions"] = "update_location_suggestions";
    LocationActionTypes["resetLocation"] = "reset_location";
})(LocationActionTypes || (LocationActionTypes = {}));
var CompanyActionTypes;
(function(CompanyActionTypes) {
    CompanyActionTypes["updateCompany"] = "update_company";
    CompanyActionTypes["updateCompanySuggestions"] = "update_company_suggestions";
    CompanyActionTypes["resetCompany"] = "reset_company";
})(CompanyActionTypes || (CompanyActionTypes = {}));
var FiltersActionTypes;
(function(FiltersActionTypes) {
    FiltersActionTypes["updateFilter"] = "update_filter";
    FiltersActionTypes["resetAllFilters"] = "reset_all_filters";
})(FiltersActionTypes || (FiltersActionTypes = {}));
var KeywordActionTypes;
(function(KeywordActionTypes) {
    KeywordActionTypes["updateKeyword"] = "update_keyword";
    KeywordActionTypes["resetKeyword"] = "reset_keyword";
})(KeywordActionTypes || (KeywordActionTypes = {}));
var UserInteractionActionTypes;
(function(UserInteractionActionTypes) {
    UserInteractionActionTypes["updateJobTileViews"] = "update_job_tile_views";
    UserInteractionActionTypes["updateFilterInteraction"] = "update_filter_interaction";
    UserInteractionActionTypes["resetJobTileViews"] = "reset_job_tile_views";
})(UserInteractionActionTypes || (UserInteractionActionTypes = {}));
var UrlActionTypes;
(function(UrlActionTypes) {
    UrlActionTypes["updateUrl"] = "update_url";
})(UrlActionTypes || (UrlActionTypes = {}));
var WindowLocationActionTypes;
(function(WindowLocationActionTypes) {
    WindowLocationActionTypes["updateWindowLocation"] = "update_window_location";
})(WindowLocationActionTypes || (WindowLocationActionTypes = {}));
var SearchIdActionTypes;
(function(SearchIdActionTypes) {
    SearchIdActionTypes["updateSearchId"] = "update_search_id";
})(SearchIdActionTypes || (SearchIdActionTypes = {}));


/***/ }),

/***/ 3098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; },
  "getInitialFilterParams": function() { return /* binding */ getInitialFilterParams; },
  "getInitialSearchId": function() { return /* binding */ getInitialSearchId; },
  "setInitialSearchState": function() { return /* binding */ setInitialSearchState; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(7632);
// EXTERNAL MODULE: ./node_modules/@themuse/experiment-client/build/index.js
var build = __webpack_require__(6680);
// EXTERNAL MODULE: ./node_modules/@themuse/snowplow-js-client/build/index.js
var snowplow_js_client_build = __webpack_require__(8580);
// EXTERNAL MODULE: ./src/utils/tracking.tsx
var tracking = __webpack_require__(1771);
// EXTERNAL MODULE: ./src/hooks/UserContext.tsx
var UserContext = __webpack_require__(9652);
// EXTERNAL MODULE: ./src/utils/searchFacetItems.ts
var searchFacetItems = __webpack_require__(4299);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/utils/logging.js
var logging = __webpack_require__(5023);
// EXTERNAL MODULE: ./src/utils/browser.ts
var browser = __webpack_require__(7228);
// EXTERNAL MODULE: ./src/utils/strings.ts
var strings = __webpack_require__(2918);
;// CONCATENATED MODULE: ./src/selectors/index.ts
const initialLocationList = [
    {
        label: "Remote / Flexible",
        value: "Remote / Flexible",
        latitude: null,
        longitude: null,
        remote_work_location_type: "virtual",
        id: 0
    },
    {
        label: "New York, NY",
        value: "New York, NY",
        latitude: 40.709999084472656,
        longitude: -74.01000213623047,
        remote_work_location_type: null,
        id: 5852770
    },
    {
        label: "San Francisco, CA",
        value: "San Francisco, CA",
        latitude: 37.77492904663086,
        longitude: -122.41941833496094,
        remote_work_location_type: null,
        id: 5834763
    },
    {
        label: "Los Angeles, CA",
        value: "Los Angeles, CA",
        latitude: 34.0522346496582,
        longitude: -118.24368286132812,
        remote_work_location_type: null,
        id: 5834138
    },
    {
        label: "Boston, MA",
        value: "Boston, MA",
        latitude: 42.36008071899414,
        longitude: -71.05888366699219,
        remote_work_location_type: null,
        id: 5845716
    },
    {
        label: "Washington, DC",
        value: "Washington, DC",
        latitude: 38.90719223022461,
        longitude: -77.03687286376953,
        remote_work_location_type: null,
        id: 5831724
    },
    {
        label: "Austin, TX",
        value: "Austin, TX",
        latitude: 30.267152786254883,
        longitude: -97.74305725097656,
        remote_work_location_type: null,
        id: 5862957
    },
    {
        label: "Chicago, IL",
        value: "Chicago, IL",
        latitude: 41.87811279296875,
        longitude: -87.62979888916016,
        remote_work_location_type: null,
        id: 5838173
    },
    {
        label: "Seattle, WA",
        value: "Seattle, WA",
        latitude: 47.60620880126953,
        longitude: -122.33206939697266,
        remote_work_location_type: null,
        id: 5865100
    },
    {
        label: "Atlanta, GA",
        value: "Atlanta, GA",
        latitude: 33.74899673461914,
        longitude: -84.38798522949219,
        remote_work_location_type: null,
        id: 5837145
    }
];
const unSelectedLocation = {
    label: "",
    latitude: null,
    longitude: null,
    remote_work_location_type: null,
    value: ""
};
const defaultInitialSearchLocation = {
    label: "",
    latitude: null,
    longitude: null,
    remote_work_location_type: null,
    value: ""
};
/**
 * Returns a selected location based on certain conditions.
 */ const selectedLocationSelector = (location)=>{
    const { userSelectedLocation =unSelectedLocation  } = location;
    const { latitude , remote_work_location_type ,  } = userSelectedLocation ?? defaultInitialSearchLocation;
    return !latitude && remote_work_location_type !== "virtual" ? defaultInitialSearchLocation : userSelectedLocation;
};
/**
 * Extracts the locationSuggestions and returns either the new suggestions or the default ones.
 */ const locationSuggestionsSelector = (location)=>{
    const { locationSuggestions  } = location;
    return locationSuggestions?.length ? locationSuggestions : initialLocationList;
};
/**
 * Extracts properties from search state and constructs an object containing the extracted and derived properties.
 */ const searchResultsSelector = (searchState)=>{
    const { location ={} , company ={} , keyword , filters , userInteractions , url , preference , searchId  } = searchState;
    const searchResultsLocation = selectedLocationSelector(location);
    const locationName = searchResultsLocation?.value ?? "";
    const { latitude , longitude  } = searchResultsLocation || {};
    // Checking for the userSelectedLocation value makes sure that the carmen location is not included in the request
    const latlng = latitude && longitude ? `${latitude},${longitude}` : null;
    const remoteOption = searchResultsLocation?.remote_work_location_type;
    // Get company-derived parameters
    const companyName = company.userSelectedCompany?.label;
    const companyShortName = company.userSelectedCompany?.value;
    // Get category-derived parameters;
    const category = filters?.category.length === 1 ? filters?.category[0] : null;
    // Get keyword-derived parameters
    const searchKeyword = keyword.userInputValue;
    return {
        company,
        location,
        keyword,
        filters,
        locationName,
        latitude,
        longitude,
        latlng,
        remoteOption,
        companyName,
        companyShortName,
        category,
        searchKeyword,
        userInteractions,
        url,
        preference,
        searchId
    };
};

// EXTERNAL MODULE: ./src/hooks/SearchContext.tsx + 7 modules
var SearchContext = __webpack_require__(1366);
;// CONCATENATED MODULE: ./src/hooks/SearchFacetsContext.tsx


const defaultSearchFacetsState = {
    companyFacets: {
        perks_and_benefits: []
    }
};
const SearchFacetsStateContext = /*#__PURE__*/ react.createContext(defaultSearchFacetsState);
/**
 * Search  Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchFacetProvider>
 *   <Component />
 * </SearchFacetProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchFacetsState();
 * ```
 */ const SearchFacetsProvider = (props)=>{
    const { children , companyFacets  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFacetsStateContext.Provider, {
        value: {
            companyFacets
        },
        children: children
    });
};
const useSearchFacetsState = ()=>{
    const context = react.useContext(SearchFacetsStateContext);
    if (context === undefined) {
        throw new Error("useSearchFacetsState must be used within the SearchFacetsProvider.");
    }
    return context;
};
SearchFacetsProvider.displayName = "SearchFacetsProvider";
useSearchFacetsState.displayName = "useSearchFacetsState";


;// CONCATENATED MODULE: ./src/hooks/SearchHistoryContext.tsx











const STORAGE_NAME = "tm_search_history";
const MAX_HISTORY_ENTRIES = 5;
// Define default context value
const defaultContextValue = {
    searchHistory: [],
    addHistory: ()=>{}
};
// Create the context
const SearchHistoryContext = /*#__PURE__*/ (0,react.createContext)(defaultContextValue);
/**
 * Returns a comma-separated string of labels corresponding to the selected values.
 */ const getLabels = (selected, target)=>target.filter((x)=>selected.includes(x.value)).map((x)=>x.label).join(" \u2022 ");
/**
 * Stores the search history in the local storage and triggers a storage event.
 * Logs an error message if the search history retrieval fails.
 */ const setLocalHistory = (searchHistory)=>{
    const { publicRuntimeConfig: { appName  }  } = (0,config["default"])();
    try {
        localStorage.setItem(STORAGE_NAME, JSON.stringify(searchHistory));
        window.dispatchEvent(new Event("storage"));
    } catch (error) {
        const msg = `${appName} was unable to store the users search history: ${JSON.stringify(searchHistory)}`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
};
/**
 * Retrieves the user's search history from local storage.
 * Logs an error message if the search history retrieval fails.
 */ const getLocalHistory = ()=>{
    const { publicRuntimeConfig: { appName  }  } = (0,config["default"])();
    let result = [];
    try {
        result = JSON.parse(localStorage.getItem(STORAGE_NAME));
    } catch (error) {
        const msg = `${appName} was unable to retrieve the users search history`;
        console.error(msg, JSON.stringify((0,logging/* formatLog */.U)({
            error
        })));
    }
    return Array.isArray(result) ? result : [];
};
/**
 * Builds a string array containing various search parameters and their corresponding labels.
 * If a parameter is not selected, its label is set to null.
 */ const getArrayOfSearchFilters = ({ keyword , company , location , filters , companyFacets  })=>{
    const keywordLabel = keyword?.userInputValue === keyword?.userSelectedKeyword?.label ? keyword?.userSelectedKeyword?.label : keyword?.userInputValue;
    const perks = companyFacets.perks_and_benefits.map((x)=>x.items).flat();
    const searchFilters = [
        keywordLabel,
        company?.userSelectedCompany?.label ?? null,
        location?.userSelectedLocation?.value ?? null,
        getLabels(filters.category, searchFacetItems/* jobCategoryItems */.Y0),
        getLabels(filters.industry, searchFacetItems/* companyIndustryItems */.fA),
        getLabels(filters.experienceLevel, searchFacetItems/* experienceLevelItems */.s),
        getLabels(filters.perks, perks),
        getLabels(filters.companySize, searchFacetItems/* companySizeItems */.NB),
        getLabels(filters.companyLeadership, searchFacetItems/* diversityInclusionItems */.uq),
        searchFacetItems/* searchRadiusItems.find */.Z5.find((x)=>x.value === filters.radius)?.label ?? null,
        searchFacetItems/* postedDateRangeItems.find */.dK.find((x)=>x.value === filters.postedDateRange)?.label ?? null, 
    ];
    return searchFilters.filter(Boolean)// remove defaults that are for display only
    .filter((x)=>![
            "Anywhere",
            "Anytime"
        ].includes(x))// Split combined filters
    .map((x)=>x.split(" \u2022 "))// convert back to a single array.
    .flat()// remove leading and trailing spaces
    .map((x)=>x.trim())// Remove empties
    .filter(Boolean);
};
/**
 * Saves search history to localStorage and localState.
 */ const generateNewHistory = (props)=>{
    const { companyShortName , locationName , searchKeyword , filters , asPath , setSearchHistory , keyword , company , location , companyFacets  } = props;
    const searchFilters = getArrayOfSearchFilters({
        keyword,
        company,
        location,
        filters,
        companyFacets
    });
    // generate the path, the async nature of populating the URL means we cannot trust `window.location.pathname`.
    const path = (0,browser/* generateUrlPath */.lT)({
        companyShortName,
        locationName: (0,strings/* normalizeLocationName */.DU)(locationName),
        searchKeyword,
        filters,
        asPath
    });
    // Reasons to not generate a history
    const allowNewHistory = path && ![
        "/search/",
        "/hiring/"
    ].includes(path) && searchFilters.length && searchFilters.join(" \u2022 ");
    // Generate a history item for the current search.
    const currentSearch = allowNewHistory ? [
        {
            path,
            text: searchFilters.join(" \u2022 "),
            filters: searchFilters.length
        }
    ] : [];
    // LocalStorage history minus the current search.
    const filteredHistory = getLocalHistory().filter((x)=>x.path !== path);
    // Only return our maxim history
    const results = [
        ...currentSearch,
        ...filteredHistory
    ].flat().slice(0, MAX_HISTORY_ENTRIES);
    // push to local state
    setSearchHistory(results);
    // push to local storage
    setLocalHistory(results);
};
/**
 * Provides a context for managing search history entries.
 */ const SearchHistoryProvider = ({ children  })=>{
    const router = (0,next_router.useRouter)() || {
        asPath: ""
    };
    const { asPath  } = router;
    const { 0: searchHistory , 1: setSearchHistory  } = (0,react.useState)([]);
    const { companyFacets  } = useSearchFacetsState();
    const searchState = (0,SearchContext/* useSearchState */.XN)();
    const { company , location , keyword , filters , locationName , companyShortName , searchKeyword ,  } = searchResultsSelector(searchState);
    const updateLocalState = ()=>(event)=>{
            // we only care about these specific storage changes.
            if (event && event.key !== STORAGE_NAME) return;
            const history = getLocalHistory();
            setSearchHistory(history);
        };
    (0,react.useEffect)(()=>{
        addHistory();
    }, []);
    // Watch for changes to local storage.
    // Inject the current pages history into local storage
    (0,react.useEffect)(()=>{
        window.addEventListener("storage", updateLocalState);
        return ()=>{
            window.removeEventListener("storage", updateLocalState);
        };
    }, []);
    const addHistory = ()=>generateNewHistory({
            companyShortName,
            locationName,
            searchKeyword,
            filters,
            asPath,
            setSearchHistory,
            keyword,
            company,
            location,
            companyFacets
        });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHistoryContext.Provider, {
        value: {
            searchHistory,
            addHistory
        },
        children: children
    });
};
SearchHistoryProvider.displayName = "SearchHistoryProvider";
// Custom hook for using the SearchHistory context.
const useSearchHistory = ()=>{
    const context = (0,react.useContext)(SearchHistoryContext);
    if (context === undefined) {
        throw new Error("useSearchHistory must be used within the SearchProvider");
    }
    return context;
};

// EXTERNAL MODULE: ./src/interfaces/context/searchContextInterfaces.ts
var searchContextInterfaces = __webpack_require__(8619);
;// CONCATENATED MODULE: ./src/utils/searchFacets.ts



/**
 * Default values for radio type filters will most likely be an empty string,
 * but we want to use a more descriptive value for oskar tracking.
 */ const defaultRadioValues = {
    radius: "Anywhere",
    postedDateRange: "Anytime"
};
/**
 * Returns a default value for radio type facets
 */ const getRadioFacetValue = (field, value)=>{
    if (value === "" && field in defaultRadioValues) {
        return defaultRadioValues[field];
    }
    return value;
};
const getFilterItems = (filterItems, selectedFilters, fieldType)=>{
    const items = filterItems.map((item)=>{
        const isNested = item && "items" in item && item?.items?.length;
        const defaultChecked = fieldType === "checkbox" ? selectedFilters && selectedFilters.includes(item.value) || false : selectedFilters === item.value;
        return {
            ...item,
            defaultChecked,
            items: isNested ? getFilterItems(item.items, selectedFilters, fieldType) : []
        };
    });
    return items;
};
const getFacetPropsOnChange = ({ userInputFilterName , filters , dispatch  })=>({
        onChange: (listItem)=>{
            const { value: filterValue  } = listItem;
            let updatedFilterValues = [];
            const selectedFilterValues = filters[userInputFilterName];
            if (selectedFilterValues) {
                if (selectedFilterValues.includes(filterValue)) {
                    updatedFilterValues = selectedFilterValues.filter((value)=>value && value !== filterValue);
                } else {
                    updatedFilterValues = [
                        ...selectedFilterValues,
                        filterValue
                    ];
                }
            } else {
                updatedFilterValues = [
                    filterValue
                ];
            }
            dispatch({
                type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                payload: {
                    [userInputFilterName]: updatedFilterValues
                }
            });
            dispatch({
                type: searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction,
                payload: {
                    mobileClearAllClickedAt: null,
                    desktopClearAllClickedAt: null,
                    individualFilterClearedAt: null
                }
            });
        }
    });
const getRadioFacetPropsOnChange = ({ userInputFilterName , dispatch ,  })=>({
        onChange: (listItem)=>{
            dispatch({
                type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                payload: {
                    [userInputFilterName]: listItem.value
                }
            });
            dispatch({
                type: searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction,
                payload: {
                    individualFilterClearedAt: null,
                    mobileClearAllClickedAt: null,
                    desktopClearAllClickedAt: null
                }
            });
        }
    });
/**
 * Get props for filters
 */ const getFacetProps = (itemProps)=>{
    const { disableOnCompanySelect =false , labelText , fieldType , defaultValue ="" , searchFilterItems , userInputFilterName , filters , company , dispatch  } = itemProps;
    const { addHistory  } = useSearchHistory();
    const selectedFilters = filters[userInputFilterName];
    const filterItems = getFilterItems(searchFilterItems, selectedFilters, fieldType);
    const facetPropsCallbacks = fieldType === "checkbox" ? getFacetPropsOnChange({
        userInputFilterName,
        filters,
        dispatch
    }) : getRadioFacetPropsOnChange({
        userInputFilterName,
        dispatch
    });
    return {
        fieldType,
        items: filterItems,
        label: labelText,
        ...facetPropsCallbacks,
        onClear: ()=>{
            if ((0,browser/* isMobile */.tq)()) {
                dispatch({
                    type: searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction,
                    payload: {
                        individualFilterClearedAt: Date.now(),
                        mobileClearAllClickedAt: null,
                        desktopClearAllClickedAt: null
                    }
                });
                dispatch({
                    type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                    payload: {
                        [userInputFilterName]: defaultValue || []
                    }
                });
            }
            addHistory();
        },
        onSave: ()=>{
            if ((0,browser/* isMobile */.tq)()) {
                dispatch({
                    type: searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction,
                    payload: {
                        individualFilterClearedAt: null,
                        mobileClearAllClickedAt: null,
                        desktopClearAllClickedAt: null
                    }
                });
            }
            addHistory();
        },
        ...disableOnCompanySelect && {
            disabled: !!company?.userSelectedCompany?.value
        }
    };
};
/**
 * Returns selected filters count
 *
 * Remote checkbox updates the location reducer instead of the filters reducer,
 * so we need to check the remote_work_location_type value.
 *
 */ const getSelectedFiltersCount = (filters, remoteLocationType)=>{
    let filterCount = Object.values(filters).reduce((accumulator, value)=>{
        if (!Array.isArray(value) && !!value) {
            return accumulator + 1;
        }
        if (Array.isArray(value)) {
            return accumulator + value.length;
        }
        return accumulator;
    }, 0);
    // Account for the remote checkbox in the filter count
    if (remoteLocationType === "virtual") {
        filterCount += 1;
    }
    return filterCount;
};
const getFacetValuesFromFacetItems = (filterParamValue, facetItems)=>{
    const splitValues = decodeURIComponent(filterParamValue).split(",");
    return splitValues.map((elem)=>{
        const facetItem = facetItems.find((item)=>item.value.toLowerCase() === elem.toLowerCase());
        return facetItem ? facetItem.value : null;
    }).filter((elem)=>elem !== null);
};

// EXTERNAL MODULE: ./src/utils/featureFlags.ts
var featureFlags = __webpack_require__(7601);
;// CONCATENATED MODULE: ./src/hooks/FeatureFlagsContext.tsx



const defaultFeatureFlagsState = ()=>{
    const flags = (0,featureFlags/* getFeatureFlags */.BZ)();
    return Object.keys(flags).reduce((featureFlags, featureFlag)=>({
            ...featureFlags,
            [featureFlag]: false
        }), {});
};
const FeatureFlagsContext = /*#__PURE__*/ react.createContext(defaultFeatureFlagsState());
const FeatureFlagsProvider = (props)=>{
    const { featureFlags , children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsContext.Provider, {
        value: featureFlags,
        children: children
    });
};
const useFeatureFlagsState = ()=>{
    const context = react.useContext(FeatureFlagsContext);
    if (context === undefined) {
        throw new Error("useFeatureFlagsState must be used within the FeatureFlagsProvider");
    }
    return context;
};
FeatureFlagsProvider.displayName = "FeatureFlagsProvider";
useFeatureFlagsState.displayName = "useFeatureFlagsState";


;// CONCATENATED MODULE: ./src/hooks/SearchResultsContext.tsx


const SearchResultsStateContext = /*#__PURE__*/ react.createContext(undefined);
const SearchResultsDispatchContext = /*#__PURE__*/ react.createContext(undefined);
const searchResultsReducer = (state, action)=>{
    switch(action.type){
        case "update_results":
            {
                return {
                    ...state,
                    ...action.payload.values
                };
            }
        default:
            {
                throw new Error(`Unhandled action: ${action}`);
            }
    }
};
/**
 * Search Results Context Provider
 *
 * How to use:
 *
 * Wrap the provider around the components that need access to the context data.
 * ```
 * <SearchResultsProvider>
 *   <Component />
 * </SearchResultsProvider>
 * ```
 * Access the state in <Component />
 * ```
 * const state = useSearchResultsState();
 * ```
 * Call dispatch to update the context state
 * ```
 * const dispatch = useSearchResultsDispatch();
 * dispatch({ type: ACTION_TYPE, payload: ACTION_PAYLOAD });
 * ```
 */ const SearchResultsProvider = ({ children , ...initialState })=>{
    const [state, dispatch] = react.useReducer(searchResultsReducer, initialState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsStateContext.Provider, {
        value: state,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResultsDispatchContext.Provider, {
            value: dispatch,
            children: children
        })
    });
};
const useSearchResultsState = ()=>{
    const context = react.useContext(SearchResultsStateContext);
    if (context === undefined) {
        throw new Error("useSearchResultsState must be used within the SearchResultsProvider");
    }
    return context;
};
const useSearchResultsDispatch = ()=>{
    const context = react.useContext(SearchResultsDispatchContext);
    if (context === undefined) {
        throw new Error("useSearchResultsDispatch must be used within the SearchResultsProvider");
    }
    return context;
};
SearchResultsProvider.displayName = "SearchResultsProvider";
useSearchResultsState.displayName = "useSearchResultsState";
useSearchResultsDispatch.displayName = "useSearchResultsDispatch";


// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/components/header/Seo.tsx

/* eslint-disable max-len */ 




const Seo = (params)=>{
    const { company , keyword , location , filters  } = (0,SearchContext/* useSearchState */.XN)();
    const { searchUrl  } = params;
    const canonical = (0,strings/* getCanonicalUrl */.Z2)(searchUrl);
    const category = filters?.category.length === 1 ? filters?.category[0] : null;
    const { totalCount  } = useSearchResultsState();
    const seoTitle = (0,strings/* getSearchSeoTitle */.Y8)(location?.userSelectedLocation?.label, (0,strings/* unSlugify */.A$)(keyword?.userSelectedKeyword?.label), company?.userSelectedCompany?.label, category, totalCount);
    const title = `${seoTitle.suffix} | The Muse`;
    const description = (0,strings/* getSearchSeoDescription */.vU)(location?.userSelectedLocation?.label, (0,strings/* unSlugify */.A$)(keyword?.userSelectedKeyword?.label), company?.userSelectedCompany?.label, category, totalCount);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: canonical ? "index,follow" : "noindex,follow"
            }, "robots"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: canonical
            }, "og:url"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: canonical
            }, "canonical")
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Pages/Layout.tsx + 18 modules
var Layout = __webpack_require__(1362);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Text/Text.tsx
var Text = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SquareButton.tsx + 1 modules
var SquareButton = __webpack_require__(1410);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/CloseIcon.tsx
var CloseIcon = __webpack_require__(5151);
;// CONCATENATED MODULE: ./src/utils/searchFacetsTracking.ts


/**
 * Map search filter field names to oskar tracking fields.
 *
 * [SearchFilters.<type>]: <Oskar tracking field>
 */ const oskarFieldMapping = {
    companySize: "company_size",
    experienceLevel: "job_level",
    industry: "industry",
    perks: "perks_and_benefits",
    category: "job_categories",
    work_location: "remote_work_location_type",
    radius: "radius",
    postedDateRange: "date_posted",
    companyLeadership: "company_leadership",
    diversityAndInclusion: "diversity_and_inclusion"
};
const snowplowFilterNameMap = new Map();
snowplowFilterNameMap.set("category", "Job Category").set("companyLeadership", "Diversity & Inclusion").set("companySize", "Company Size").set("experienceLevel", "Experience Level").set("industry", "Company Industry").set("perks", "Perks & Benefits").set("postedDateRange", "Date Posted").set("radius", "Search Radius").set("company", "Company Name").set("location", "Location");
/**
 * Triggers muse track events for Applied / Removed filters.
 *
 * To support additional facets, add field mapping to oskarFieldMapping.
 */ const trackFacets = (eventName, filterSource, sourceFilters, diffFilters)=>{
    Object.keys(sourceFilters).forEach((key)=>{
        if (Array.isArray(sourceFilters[key])) {
            sourceFilters[key].forEach((filterItem)=>{
                if (oskarFieldMapping[key] && !diffFilters[key]?.includes(filterItem)) {
                    (0,tracking/* museTrack */.YU)(eventName, {
                        source: "search-listing",
                        model_type: "jobs",
                        filter_source: filterSource,
                        name: oskarFieldMapping[key],
                        value: filterItem
                    });
                }
            });
        }
        if (typeof sourceFilters[key] === "string") {
            if (sourceFilters[key] !== diffFilters[key]) {
                (0,tracking/* museTrack */.YU)(eventName, {
                    source: "search-listing",
                    model_type: "jobs",
                    filter_source: filterSource,
                    name: oskarFieldMapping[key],
                    value: getRadioFacetValue(key, sourceFilters[key])
                });
            }
        }
    });
};
const buildSnowplowFilterItems = (filters, location, company)=>{
    const items = [];
    const modifiedFilters = {
        ...filters
    };
    if (location) {
        Object.assign(modifiedFilters, {
            location: [
                location
            ]
        });
    }
    if (filters.location && !location) {
        delete modifiedFilters.location;
    }
    if (company) {
        Object.assign(modifiedFilters, {
            company: [
                company
            ]
        });
    }
    if (filters.company && !company) {
        delete modifiedFilters.company;
    }
    Object.keys(modifiedFilters).forEach((key)=>{
        if (!snowplowFilterNameMap.get(key) || !modifiedFilters[key].length) return;
        if (Array.isArray(modifiedFilters[key])) {
            modifiedFilters[key].forEach((val)=>{
                items.push({
                    filter_name: snowplowFilterNameMap.get(key),
                    filter_value: val
                });
            });
        } else {
            items.push({
                filter_name: snowplowFilterNameMap.get(key),
                filter_value: modifiedFilters[key]
            });
        }
    });
    return items;
};

// EXTERNAL MODULE: ./src/components/facets/SearchFacets.module.scss
var SearchFacets_module = __webpack_require__(3223);
var SearchFacets_module_default = /*#__PURE__*/__webpack_require__.n(SearchFacets_module);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilter.tsx + 5 modules
var SearchFilter = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Buttons/SearchFilterButton/SearchFilterCheckbox.tsx
var SearchFilterCheckbox = __webpack_require__(7076);
;// CONCATENATED MODULE: ./src/components/facets/jobs/JobFacets.tsx








const JobFacets = (props)=>{
    const { remoteIsSelected , updateRemoteIsSelected , locationIsSelected , ...rest } = props;
    const { addHistory  } = useSearchHistory();
    const remoteCheckboxFacetProps = {
        label: "Remote/Flexible Only",
        checked: remoteIsSelected,
        onChange: ()=>{
            updateRemoteIsSelected(remoteIsSelected);
            addHistory();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFacets_module_default()).jobFilterSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (SearchFacets_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    htmlTag: "h2",
                    textStyle: "heading-3",
                    className: classnames_default()((SearchFacets_module_default()).headerText, (SearchFacets_module_default()).subHeaderText),
                    children: "Job Filters"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchFacets_module_default()).facetList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            fieldType: "radio",
                            userInputFilterName: "postedDateRange",
                            searchFilterItems: searchFacetItems/* postedDateRangeItems */.dK,
                            labelText: "Date Posted",
                            defaultValue: "",
                            ...rest
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            fieldType: "checkbox",
                            userInputFilterName: "category",
                            searchFilterItems: searchFacetItems/* jobCategoryItems */.Y0,
                            labelText: "Job Category",
                            ...rest
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            fieldType: "checkbox",
                            userInputFilterName: "experienceLevel",
                            searchFilterItems: searchFacetItems/* experienceLevelItems */.s,
                            labelText: "Experience Level",
                            ...rest
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilterCheckbox/* default */.Z, {
                        ...remoteCheckboxFacetProps
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            fieldType: "radio",
                            userInputFilterName: "radius",
                            searchFilterItems: searchFacetItems/* searchRadiusItems */.Z5,
                            labelText: "Search Radius",
                            defaultValue: "",
                            ...rest
                        }),
                        disabled: !locationIsSelected
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var jobs_JobFacets = (JobFacets);

;// CONCATENATED MODULE: ./src/components/facets/companies/CompanyFacets.tsx

/* eslint-disable camelcase */ 






const CompanyFacets = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { companyFacets  } = useSearchFacetsState();
    const { perks_and_benefits  } = companyFacets;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFacets_module_default()).companyFilterSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: (SearchFacets_module_default()).header,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    htmlTag: "h2",
                    textStyle: "heading-3",
                    className: classnames_default()((SearchFacets_module_default()).headerText, (SearchFacets_module_default()).subHeaderText),
                    children: "Company Filters"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchFacets_module_default()).facetList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            ...props,
                            fieldType: "checkbox",
                            disableOnCompanySelect: true,
                            userInputFilterName: "industry",
                            searchFilterItems: searchFacetItems/* companyIndustryItems */.fA,
                            labelText: "Company Industry"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            ...props,
                            fieldType: "checkbox",
                            disableOnCompanySelect: true,
                            userInputFilterName: "companySize",
                            searchFilterItems: searchFacetItems/* companySizeItems */.NB,
                            labelText: "Company Size"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            ...props,
                            fieldType: "checkbox",
                            disableOnCompanySelect: true,
                            userInputFilterName: "perks",
                            searchFilterItems: (0,searchFacetItems/* flattenPerksAndBenefits */.sg)(perks_and_benefits),
                            labelText: "Perks and Benefits"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFilter/* default */.Z, {
                        ...getFacetProps({
                            ...props,
                            fieldType: "checkbox",
                            disableOnCompanySelect: true,
                            userInputFilterName: "companyLeadership",
                            searchFilterItems: searchFacetItems/* diversityInclusionItems */.uq,
                            labelText: "Diversity & Inclusion"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var companies_CompanyFacets = (CompanyFacets);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Tooltip/Tooltip.tsx
var Tooltip = __webpack_require__(4636);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
// EXTERNAL MODULE: ./src/components/facets/RecentSearches.module.scss
var RecentSearches_module = __webpack_require__(4744);
var RecentSearches_module_default = /*#__PURE__*/__webpack_require__.n(RecentSearches_module);
;// CONCATENATED MODULE: ./src/components/facets/RecentSearches.tsx








/**
 * Returns a JSON string representing the click tracking data for a specific link within the RecentSearch Module.
 */ const getClickTracking = (text, searchId)=>({
        sp_tile_type: null,
        sp_tile_entity_id: null,
        sp_click_component: "link",
        sp_click_link_text: text.length > 155 ? `${text.slice(0, 152)}...` : text,
        sp_click_position: "left_rail",
        sp_click_target_page_section: "search",
        sp_click_search_id: searchId
    });
/**
 * Returns a JSON string representing the impression tracking data for the RecentSearch Module.
 */ const getImpressionTracking = (searchId)=>JSON.stringify({
        sp_impression_component: "insert",
        sp_impression_insert_type: "recent_searches",
        sp_impression_position: "left_rail",
        sp_impression_search_id: searchId
    });
/**
 * Triggers a click event for snowplow tracking purposes.
 */ const triggerClickEvent = (event, searchId)=>{
    const text = event.currentTarget.innerText;
    const tracking = getClickTracking(text, searchId);
    (0,snowplow_js_client_build.triggerSnowplowClickEvent)(tracking);
};
/**
 * React component for displaying recent searches with click tracking and impression events.
 * Utilizes search history and search state hooks to render recent search items with tooltips.
 */ const RecentSearches = ()=>{
    const { 0: open , 1: setOpen  } = (0,react.useState)(false);
    const { searchHistory  } = useSearchHistory();
    const { searchId  } = (0,SearchContext/* useSearchState */.XN)();
    const panelView = (0,react_intersection_observer_modern/* useInView */.YD)({
        triggerOnce: true,
        rootMargin: "0px"
    });
    const { 0: recentSearchesViewed , 1: setRecentSearchesViewed  } = (0,react.useState)(false);
    // Trigger snowplow impression once. If the pane is visible.
    (0,react.useEffect)(()=>{
        if (panelView.inView && !recentSearchesViewed) {
            (0,snowplow_js_client_build.triggerSnowplowImpressionEvent)(panelView.entry.target);
            setRecentSearchesViewed(true);
        }
    }, [
        panelView.inView
    ]);
    // Nothing in local storage, do not render.
    if (!searchHistory?.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: (RecentSearches_module_default()).heading,
                children: "Recent Searches"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (RecentSearches_module_default()).RecentSearches,
                ref: panelView.ref,
                "data-tracking-event-type": "impression",
                "data-tracking-props": getImpressionTracking(searchId),
                children: [
                    searchHistory.map((searchItem, index)=>{
                        const { path , text , filters  } = searchItem;
                        const content = text.split(" \u2022 ");
                        const linkStyle = index === 0 ? `${(RecentSearches_module_default()).link} ${(RecentSearches_module_default()).current}` : (RecentSearches_module_default()).link;
                        let tipStyle = null;
                        if (content.length > 20) tipStyle = (RecentSearches_module_default()).toolTipTwoColum;
                        if (content.length > 40) tipStyle = (RecentSearches_module_default()).toolTipThreeColum;
                        return open || index <= 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: `${(RecentSearches_module_default()).search} ${tipStyle}`,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: linkStyle,
                                    href: path,
                                    onClick: (event)=>triggerClickEvent(event, searchId),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: text
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                    title: path,
                                    triggerText: filters.toString(),
                                    content
                                })
                            ]
                        }, path) : null;
                    }),
                    searchHistory.length > 2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: ()=>setOpen(!open),
                        className: (RecentSearches_module_default()).moreLess,
                        children: open ? "VIEW LESS" : "VIEW MORE"
                    }) : null
                ]
            })
        ]
    });
};
RecentSearches.displayName = "RecentSearches";

;// CONCATENATED MODULE: ./src/components/facets/SearchFacets.tsx
















const SearchFacets = (props)=>{
    const { onClose , onFiltersChange  } = props;
    const { company , location , filters , userInteractions  } = (0,SearchContext/* useSearchState */.XN)();
    const searchDispatch = (0,SearchContext/* useSearchDispatch */.bn)();
    const [selectedFiltersState, setSelectedFiltersState] = react.useState(filters);
    const searchResultsState = useSearchResultsState();
    const isRemoteType = location?.userSelectedLocation?.remote_work_location_type === "virtual";
    react.useEffect(()=>{
        let filterSource = "individual_filter";
        if (userInteractions?.mobileClearAllClickedAt || userInteractions?.desktopClearAllClickedAt) {
            filterSource = "clear_all_filters_button";
        } else if (userInteractions?.individualFilterClearedAt) {
            filterSource = "clear_individual_filter_button";
        }
        // Filter was applied if values in filters does not exist in selectedFiltersState
        trackFacets("Applied Filter", filterSource, filters, selectedFiltersState);
        // Filter was removed if values in selectedFiltersState does not exist in filters
        trackFacets("Removed Filter", filterSource, selectedFiltersState, filters);
        setSelectedFiltersState(filters);
    }, [
        filters
    ]);
    const clearFilters = ()=>{
        searchDispatch({
            type: searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction,
            payload: {
                [(0,browser/* isMobile */.tq)() ? "mobileClearAllClickedAt" : "desktopClearAllClickedAt"]: Date.now()
            }
        });
        searchDispatch({
            type: searchContextInterfaces/* FiltersActionTypes.resetAllFilters */.bL.resetAllFilters
        });
        // Reset the remote checkbox is remote is selected
        if (isRemoteType) {
            searchDispatch({
                type: searchContextInterfaces/* LocationActionTypes.resetLocation */.B3.resetLocation
            });
        }
        onFiltersChange?.();
    };
    const filterCount = getSelectedFiltersCount(filters, location?.userSelectedLocation?.remote_work_location_type);
    const clearMessage = `Clear ${filterCount} filter${filterCount > 1 ? "s" : ""}`;
    const viewResultsCount = searchResultsState.totalCount >= 10000 ? "10,000+" : (0,strings/* formatNumberComma */.ai)(searchResultsState.totalCount);
    const viewResultsMessage = `View ${viewResultsCount} Result${searchResultsState.totalCount > 1 ? "s" : ""}`;
    const viewResultsOnClick = ()=>{
        onClose();
        if ((0,browser/* isMobile */.tq)()) {
            (0,browser/* toggleWindowFreeze */.LF)();
        }
    };
    const dispatchUpdateRemoteCheckbox = (remoteIsSelected)=>{
        let payload = {
            userInputValue: "",
            userSelectedLocation: null
        };
        if (!remoteIsSelected) {
            payload = {
                userInputValue: "Remote / Flexible",
                userSelectedLocation: {
                    label: "Remote / Flexible",
                    value: "Remote / Flexible",
                    latitude: null,
                    longitude: null,
                    remote_work_location_type: "virtual"
                }
            };
        }
        searchDispatch({
            type: searchContextInterfaces/* LocationActionTypes.updateLocation */.B3.updateLocation,
            payload
        });
        if (filters?.radius) {
            searchDispatch({
                type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                payload: {
                    radius: ""
                }
            });
        }
    };
    const locationIsSelected = !!location?.userSelectedLocation?.value && !!location?.userSelectedLocation?.latitude && !!location?.userSelectedLocation?.longitude && !isRemoteType;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchFacets_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: classnames_default()((SearchFacets_module_default()).mainHeader, (SearchFacets_module_default()).header),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        textStyle: "heading-3",
                        className: (SearchFacets_module_default()).headerText,
                        children: "All Filters"
                    }),
                    filterCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        className: (SearchFacets_module_default()).headerButton,
                        onClick: clearFilters,
                        children: "Clear All"
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentSearches, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (SearchFacets_module_default()).facetWrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jobs_JobFacets, {
                        filters: filters,
                        company: company,
                        dispatch: searchDispatch,
                        remoteIsSelected: isRemoteType,
                        updateRemoteIsSelected: dispatchUpdateRemoteCheckbox,
                        locationIsSelected: locationIsSelected
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(companies_CompanyFacets, {
                        filters: filters,
                        company: company,
                        dispatch: searchDispatch
                    })
                ]
            }),
            filterCount > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                className: (SearchFacets_module_default()).clearFacets,
                onClick: clearFilters,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon/* default */.Z, {
                        className: (SearchFacets_module_default()).clearFacetsIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        textStyle: "sans-serif-body-small",
                        htmlTag: "span",
                        className: (SearchFacets_module_default()).clearFacetsText,
                        children: clearMessage
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                className: (SearchFacets_module_default()).footer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
                    className: (SearchFacets_module_default()).viewResults,
                    color: "secondary-100",
                    onClick: viewResultsOnClick,
                    children: viewResultsMessage
                })
            })
        ]
    });
};
/* harmony default export */ var facets_SearchFacets = (SearchFacets);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableDropdown/DropdownProvider.tsx + 3 modules
var DropdownProvider = __webpack_require__(5085);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useDebounce.js + 1 modules
var useDebounce = __webpack_require__(5386);
// EXTERNAL MODULE: ./node_modules/downshift/dist/downshift.esm.js + 1 modules
var downshift_esm = __webpack_require__(8783);
// EXTERNAL MODULE: ./src/orm/locations.ts
var locations = __webpack_require__(7248);
// EXTERNAL MODULE: ./src/utils/api.ts + 9 modules
var api = __webpack_require__(3309);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Dropdowns/ComposableSearchDropdown.tsx + 1 modules
var ComposableSearchDropdown = __webpack_require__(2821);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/IconCompany.tsx
var IconCompany = __webpack_require__(452);
// EXTERNAL MODULE: ./src/utils/constants.ts
var constants = __webpack_require__(3135);
// EXTERNAL MODULE: ./src/styles/Home.module.scss
var Home_module = __webpack_require__(4865);
var Home_module_default = /*#__PURE__*/__webpack_require__.n(Home_module);
// EXTERNAL MODULE: ./src/components/header/SearchInput.module.scss
var SearchInput_module = __webpack_require__(7334);
var SearchInput_module_default = /*#__PURE__*/__webpack_require__.n(SearchInput_module);
;// CONCATENATED MODULE: ./src/components/header/CompanySearchInput.tsx







const menuToggle = (value)=>{
    const navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach((elem)=>{
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
const CompanySearchInput = (props)=>{
    const { company , clear , onInputChange , noResultsMessage  } = props;
    const { companySuggestions , userSelectedCompany  } = company;
    const placeHolderText = "All Companies";
    const dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconCompany/* default */.Z, {}),
            dropdownList: companySuggestions,
            dropdownTitle: "Type to select a company",
            debounceWait: 200,
            labelText: "Companies",
            placeHolderText,
            inputId: "company-input",
            maxLength: constants/* suggestionApiQueryMaxlength */.BU,
            onInputChange,
            onMenuToggle: menuToggle,
            clearValue: clear,
            fieldValue: userSelectedCompany,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableSearchDropdown/* default */.Z, {
        ...dropdownProps
    });
};
CompanySearchInput.displayName = "CompanySearchInput";
/* harmony default export */ var header_CompanySearchInput = (CompanySearchInput);

;// CONCATENATED MODULE: ./src/components/header/KeywordSearchInput.tsx






const KeywordSearchInput_menuToggle = (value)=>{
    const navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach((elem)=>{
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
const filterList = (list, value = "")=>list.filter((item)=>item.label.toLowerCase().includes(value.toLowerCase()));
const KeywordSearchInput = (props)=>{
    const { keyword , clear , onInputChange , noResultsMessage  } = props;
    const { userSelectedKeyword , userInputValue  } = keyword;
    const keywordList = [
        {
            label: "Marketing",
            value: "marketing"
        },
        {
            label: "Sales",
            value: "sales"
        },
        {
            label: "Product Management",
            value: "product manager"
        },
        {
            label: "Design",
            value: "design"
        },
        {
            label: "Software Engineering",
            value: "software engineering"
        },
        {
            label: "Human Resources",
            value: "human resources"
        },
        {
            label: "Finance",
            value: "finance"
        },
        {
            label: "Project Management",
            value: "project management"
        },
        {
            label: "Customer Care",
            value: "customer care"
        },
        {
            label: "Data Entry",
            value: "data entry"
        },
        {
            label: "Account Manager",
            value: "account manager"
        },
        {
            label: "Accountant",
            value: "accountant"
        },
        {
            label: "Accounting",
            value: "accounting"
        },
        {
            label: "Actuary",
            value: "actuary"
        },
        {
            label: "Admin",
            value: "admin"
        },
        {
            label: "Administrative",
            value: "administrative"
        },
        {
            label: "Administrative Assistant",
            value: "administrative assistant"
        },
        {
            label: "Analyst",
            value: "analyst"
        },
        {
            label: "Analytics",
            value: "analytics"
        },
        {
            label: "Art",
            value: "art"
        },
        {
            label: "Art Director",
            value: "art director"
        },
        {
            label: "Assistant",
            value: "assistant"
        },
        {
            label: "Associate Consultant",
            value: "associate consultant"
        },
        {
            label: "Brand Manager",
            value: "brand manager"
        },
        {
            label: "Brand Marketing",
            value: "brand marketing"
        },
        {
            label: "Business",
            value: "business"
        },
        {
            label: "Business Analyst",
            value: "business analyst"
        },
        {
            label: "Business Development",
            value: "business development"
        },
        {
            label: "Chief Of Staff",
            value: "chief of staff"
        },
        {
            label: "Clinical Educator",
            value: "clinical educator"
        },
        {
            label: "Coach",
            value: "coach"
        },
        {
            label: "Communication",
            value: "communication"
        },
        {
            label: "Communications",
            value: "communications"
        },
        {
            label: "Community Health Worker",
            value: "community health worker"
        },
        {
            label: "Community Manager",
            value: "community manager"
        },
        {
            label: "Compensation And Benefits Manager",
            value: "compensation and benefits manager"
        },
        {
            label: "Compliance",
            value: "compliance"
        },
        {
            label: "Computer Programmer",
            value: "computer programmer"
        },
        {
            label: "Content",
            value: "content"
        },
        {
            label: "Content Marketing",
            value: "content marketing"
        },
        {
            label: "Content Marketing Manager",
            value: "content marketing manager"
        },
        {
            label: "Content Writer",
            value: "content writer"
        },
        {
            label: "Coordinator",
            value: "coordinator"
        },
        {
            label: "Copy Editor",
            value: "copy editor"
        },
        {
            label: "Copywriter",
            value: "copywriter"
        },
        {
            label: "Corporate Communications",
            value: "corporate communications"
        },
        {
            label: "Creative",
            value: "creative"
        },
        {
            label: "Creative Director",
            value: "creative director"
        },
        {
            label: "Curriculum Developer",
            value: "curriculum developer"
        },
        {
            label: "Customer",
            value: "customer"
        },
        {
            label: "Customer Service",
            value: "customer service"
        },
        {
            label: "Customer Service Representative",
            value: "customer service representative"
        },
        {
            label: "Customer Success",
            value: "customer success"
        },
        {
            label: "Customer Success Manager",
            value: "customer success manager"
        },
        {
            label: "Customer Support",
            value: "customer support"
        },
        {
            label: "Data",
            value: "data"
        },
        {
            label: "Data Analyst",
            value: "data analyst"
        },
        {
            label: "Data Entry Clerk",
            value: "data entry clerk"
        },
        {
            label: "Data Intern",
            value: "data intern"
        },
        {
            label: "Data Management Analyst",
            value: "data management analyst"
        },
        {
            label: "Data Science",
            value: "data science"
        },
        {
            label: "Data Science Manager",
            value: "data science manager"
        },
        {
            label: "Data Scientist",
            value: "data scientist"
        },
        {
            label: "Database Administrator",
            value: "database administrator"
        },
        {
            label: "Digital Marketing",
            value: "digital marketing"
        },
        {
            label: "Director",
            value: "director"
        },
        {
            label: "Diversity Manager",
            value: "diversity manager"
        },
        {
            label: "Editing",
            value: "editing"
        },
        {
            label: "Editor",
            value: "editor"
        },
        {
            label: "Editorial Assistant",
            value: "editorial assistant"
        },
        {
            label: "Education",
            value: "education"
        },
        {
            label: "Engineering",
            value: "engineering"
        },
        {
            label: "English Teacher",
            value: "english teacher"
        },
        {
            label: "Enterprise Sales Executive",
            value: "enterprise sales executive"
        },
        {
            label: "Entry Level",
            value: "entry level"
        },
        {
            label: "Environmental Restoration Planner",
            value: "environmental restoration planner"
        },
        {
            label: "Event",
            value: "event"
        },
        {
            label: "Executive",
            value: "executive"
        },
        {
            label: "Executive Assistant",
            value: "executive assistant"
        },
        {
            label: "Fashion",
            value: "fashion"
        },
        {
            label: "Financial Analyst",
            value: "financial analyst"
        },
        {
            label: "Financial Manager",
            value: "financial manager"
        },
        {
            label: "Graphic Design",
            value: "graphic design"
        },
        {
            label: "Graphic Designer",
            value: "graphic designer"
        },
        {
            label: "Health",
            value: "health"
        },
        {
            label: "Healthcare",
            value: "healthcare"
        },
        {
            label: "HR",
            value: "hr"
        },
        {
            label: "HR Associate",
            value: "hr associate"
        },
        {
            label: "HR Manager",
            value: "hr manager"
        },
        {
            label: "HRIS Manager",
            value: "hris manager"
        },
        {
            label: "Industrial Engineer",
            value: "industrial engineer"
        },
        {
            label: "Information Security Analyst",
            value: "information security analyst"
        },
        {
            label: "Information Technology",
            value: "information technology"
        },
        {
            label: "Insurance Sales Agent",
            value: "insurance sales agent"
        },
        {
            label: "Intern",
            value: "intern"
        },
        {
            label: "Internal Auditing Manager",
            value: "internal auditing manager"
        },
        {
            label: "Internship",
            value: "internship"
        },
        {
            label: "Internships",
            value: "internships"
        },
        {
            label: "Interpreter",
            value: "interpreter"
        },
        {
            label: "Interview",
            value: "interview"
        },
        {
            label: "Learning",
            value: "learning"
        },
        {
            label: "Learning And Development",
            value: "learning and development"
        },
        {
            label: "Learning And Development Specialist",
            value: "learning and development specialist"
        },
        {
            label: "Legal",
            value: "legal"
        },
        {
            label: "Loan Officer",
            value: "loan officer"
        },
        {
            label: "Management Consultant",
            value: "management consultant"
        },
        {
            label: "Manager",
            value: "manager"
        },
        {
            label: "Marketing Analyst",
            value: "marketing analyst"
        },
        {
            label: "Marketing Consultant",
            value: "marketing consultant"
        },
        {
            label: "Marketing Manager",
            value: "marketing manager"
        },
        {
            label: "Marketing Specialist",
            value: "marketing specialist"
        },
        {
            label: "Mechanical Engineer",
            value: "mechanical engineer"
        },
        {
            label: "Medical Device Sales",
            value: "medical device sales"
        },
        {
            label: "Medical Writer",
            value: "medical writer"
        },
        {
            label: "Mental Health",
            value: "mental health"
        },
        {
            label: "Nonprofit",
            value: "nonprofit"
        },
        {
            label: "Nonprofits",
            value: "nonprofits"
        },
        {
            label: "Operations",
            value: "operations"
        },
        {
            label: "Operations Research Analyst",
            value: "operations research analyst"
        },
        {
            label: "Paralegal",
            value: "paralegal"
        },
        {
            label: "Part Time",
            value: "part time"
        },
        {
            label: "Pharmaceutical Sales",
            value: "pharmaceutical sales"
        },
        {
            label: "Pharmacist",
            value: "pharmacist"
        },
        {
            label: "Pharmacy Technician",
            value: "pharmacy technician"
        },
        {
            label: "Physician Assistant",
            value: "physician assistant"
        },
        {
            label: "Policy Analyst",
            value: "policy analyst"
        },
        {
            label: "PR",
            value: "pr"
        },
        {
            label: "PR Manager",
            value: "pr manager"
        },
        {
            label: "Procurement",
            value: "procurement"
        },
        {
            label: "Product",
            value: "product"
        },
        {
            label: "Product Manager",
            value: "product manager"
        },
        {
            label: "Product Marketing",
            value: "product marketing"
        },
        {
            label: "Program Manager",
            value: "program manager"
        },
        {
            label: "Project",
            value: "project"
        },
        {
            label: "Project Manager",
            value: "project manager"
        },
        {
            label: "Proofreader",
            value: "proofreader"
        },
        {
            label: "Public Relations",
            value: "public relations"
        },
        {
            label: "Python",
            value: "python"
        },
        {
            label: "Real Estate",
            value: "real estate"
        },
        {
            label: "Recruiter",
            value: "recruiter"
        },
        {
            label: "Registered Nurse",
            value: "registered nurse"
        },
        {
            label: "Regulatory Affairs Manager",
            value: "regulatory affairs manager"
        },
        {
            label: "Remote",
            value: "remote"
        },
        {
            label: "Research",
            value: "research"
        },
        {
            label: "Research Analyst",
            value: "research analyst"
        },
        {
            label: "Sales Consultant",
            value: "sales consultant"
        },
        {
            label: "Sales Engineer",
            value: "sales engineer"
        },
        {
            label: "Sales Representative",
            value: "sales representative"
        },
        {
            label: "Salesforce",
            value: "salesforce"
        },
        {
            label: "School Counselor",
            value: "school counselor"
        },
        {
            label: "Scrum Master",
            value: "scrum master"
        },
        {
            label: "Security",
            value: "security"
        },
        {
            label: "Senior Product Management Director",
            value: "senior product management director"
        },
        {
            label: "Senior UX Designer",
            value: "senior ux designer"
        },
        {
            label: "SEO",
            value: "seo"
        },
        {
            label: "Social Media",
            value: "social media"
        },
        {
            label: "Social Media Coordinator",
            value: "social media coordinator"
        },
        {
            label: "Social Media Manager",
            value: "social media manager"
        },
        {
            label: "Social Worker",
            value: "social worker"
        },
        {
            label: "Software",
            value: "software"
        },
        {
            label: "Software Developer",
            value: "software developer"
        },
        {
            label: "Software Engineer",
            value: "software engineer"
        },
        {
            label: "Software Sales Executive",
            value: "software sales executive"
        },
        {
            label: "Solutions Architect",
            value: "solutions architect"
        },
        {
            label: "Strategy",
            value: "strategy"
        },
        {
            label: "Supply Chain",
            value: "supply chain"
        },
        {
            label: "Sustainability",
            value: "sustainability"
        },
        {
            label: "Teacher",
            value: "teacher"
        },
        {
            label: "Teaching Assistant",
            value: "teaching assistant"
        },
        {
            label: "Technical Writer",
            value: "technical writer"
        },
        {
            label: "Training",
            value: "training"
        },
        {
            label: "Translator",
            value: "translator"
        },
        {
            label: "Tutor",
            value: "tutor"
        },
        {
            label: "User Experience",
            value: "user experience"
        },
        {
            label: "UX",
            value: "ux"
        },
        {
            label: "UX Design",
            value: "ux design"
        },
        {
            label: "UX Designer",
            value: "ux designer"
        },
        {
            label: "UX Researcher",
            value: "ux researcher"
        },
        {
            label: "Video",
            value: "video"
        },
        {
            label: "Virtual Assistant",
            value: "virtual assistant"
        },
        {
            label: "Web Developer",
            value: "web developer"
        },
        {
            label: "Work From Home",
            value: "work from home"
        },
        {
            label: "Writer",
            value: "writer"
        },
        {
            label: "Writing",
            value: "writing"
        }, 
    ];
    const dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            dropdownList: filterList(keywordList, userInputValue),
            dropdownTitle: "Type to search for a job",
            onInputChange,
            inputId: "keyword-input",
            onMenuToggle: KeywordSearchInput_menuToggle,
            labelText: "Keyword",
            maxLength: constants/* jobSearchQueryMaxlength */.L8,
            clearValue: clear,
            fieldValue: userSelectedKeyword,
            noResultsMessage,
            placeHolderText: "Job title, keywords"
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableSearchDropdown/* default */.Z, {
        ...dropdownProps
    });
};
KeywordSearchInput.displayName = "KeywordSearchInput";
/* harmony default export */ var header_KeywordSearchInput = (KeywordSearchInput);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/LocationShape.tsx
var LocationShape = __webpack_require__(9400);
;// CONCATENATED MODULE: ./src/components/header/LocationSearchInput.tsx







const LocationSearchInput_menuToggle = (value)=>{
    const navHeader = document.querySelectorAll("header[class^='Header_header']");
    navHeader.forEach((elem)=>{
        if (value) {
            elem.classList.add((Home_module_default()).inputMenuOpen);
        } else {
            elem.classList.remove((Home_module_default()).inputMenuOpen);
        }
    });
};
const LocationSearchInput_filterList = (list, value = "")=>list.filter((item)=>item?.label?.toLowerCase().includes(value?.toLowerCase()));
const LocationSearchInput = (props)=>{
    const { location , clear , onClear , onInputChange , noResultsMessage  } = props;
    const { locationSuggestions , userSelectedLocation , userInputValue  } = location;
    const placeHolderText = "Anywhere";
    const dropdownProps = {
        classes: {
            container: (SearchInput_module_default()).searchInputContainer,
            inputIcon: (SearchInput_module_default()).inputIcon
        },
        dropdownProps: {
            dropdownList: LocationSearchInput_filterList(locationSuggestions, userInputValue),
            IconComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationShape/* default */.Z, {}),
            dropdownTitle: "Type to select a location",
            debounceWait: 200,
            labelText: "Locations",
            placeHolderText,
            inputId: "location-input",
            maxLength: constants/* suggestionApiQueryMaxlength */.BU,
            onInputChange,
            onMenuToggle: LocationSearchInput_menuToggle,
            clearValue: clear,
            onClear,
            fieldValue: userSelectedLocation,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComposableSearchDropdown/* default */.Z, {
        ...dropdownProps
    });
};
LocationSearchInput.displayName = "LocationSearchInput";
/* harmony default export */ var header_LocationSearchInput = (LocationSearchInput);

;// CONCATENATED MODULE: ./src/components/header/SearchInput.tsx



// eslint-disable-next-line import/no-extraneous-dependencies














const SearchButton = (props)=>{
    const { onClick  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SquareButton/* default */.Z, {
        className: (SearchInput_module_default()).inputSubmit,
        color: "secondary-100",
        onClick: onClick,
        children: "Search"
    });
};
const NoResults = ()=>{
    const { onClearButtonClick  } = react.useContext(DropdownProvider/* DropdownContext */.D);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "No matches. Please",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: (SearchInput_module_default()).noResultsButton,
                onClick: onClearButtonClick,
                type: "button",
                children: "try another search."
            })
        ]
    });
};
const NoResultsKeyword = ()=>{
    const { closeMenu , inputValue  } = react.useContext(DropdownProvider/* DropdownContext */.D);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (SearchInput_module_default()).noResultsButtonKeyword,
        onClick: closeMenu,
        type: "button",
        children: [
            'See all results for "',
            inputValue,
            '"'
        ]
    });
};
const SearchInput = (props)=>{
    const { clearInputs , onClear  } = props;
    const searchState = (0,SearchContext/* useSearchState */.XN)();
    const { addHistory  } = useSearchHistory();
    const { location , company  } = searchState;
    const locationUserInput = location.userInputValue ?? null;
    const companyUserInput = company.userInputValue ?? null;
    const searchDispatch = (0,SearchContext/* useSearchDispatch */.bn)();
    const clearValues = ()=>{
        onClear?.();
    };
    const setLocationSuggestions = async (locationInput)=>{
        if (typeof locationInput === "undefined") {
            return;
        }
        const rawSuggestions = await (0,api/* fetchLocationSuggestions */.gy)(locationInput);
        const suggestions = (0,locations/* formatLocations */.i)(rawSuggestions);
        searchDispatch({
            type: searchContextInterfaces/* LocationActionTypes.updateLocationSuggestions */.B3.updateLocationSuggestions,
            payload: {
                locationSuggestions: suggestions
            }
        });
    };
    const setCompanySuggestions = async (companyInput)=>{
        if (typeof companyInput === "undefined") return;
        const suggestions = await (0,api/* fetchCompanySuggestions */.SC)(companyInput);
        searchDispatch({
            type: searchContextInterfaces/* CompanyActionTypes.updateCompanySuggestions */.iW.updateCompanySuggestions,
            payload: {
                companySuggestions: suggestions
            }
        });
    };
    react.useEffect(()=>{
        setLocationSuggestions(locationUserInput);
        addHistory();
    }, [
        locationUserInput
    ]);
    react.useEffect(()=>{
        setCompanySuggestions(companyUserInput);
        addHistory();
    }, [
        companyUserInput
    ]);
    (0,useDebounce/* default */.Z)(()=>{
        addHistory();
    }, 500, [
        searchState.keyword
    ]);
    const updateLocationInput = (changes)=>{
        const { inputValue , selectedItem , type  } = changes;
        // item was clicked from dropdown
        const itemClicked = type === downshift_esm/* useCombobox.stateChangeTypes.ItemClick */.Kb.stateChangeTypes.ItemClick;
        // reset button was clicked with menu open
        const resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        const resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        const inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        // user has entered a value into the input field
        const isEnteringData = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue !== "";
        if (isEnteringData || itemClicked) {
            searchDispatch({
                type: searchContextInterfaces/* LocationActionTypes.updateLocation */.B3.updateLocation,
                payload: {
                    userInputValue: inputValue,
                    userSelectedLocation: selectedItem
                }
            });
        }
        if (itemClicked) {
            // set initial radius if not remote/flexible
            if (!selectedItem?.remote_work_location_type) {
                searchDispatch({
                    type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                    payload: {
                        radius: searchFacetItems/* initialRadiusValue */.kh
                    }
                });
            }
        }
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            searchDispatch({
                type: searchContextInterfaces/* LocationActionTypes.updateLocation */.B3.updateLocation,
                payload: {
                    userInputValue: inputValue,
                    userSelectedLocation: null
                }
            });
            if (searchState?.filters?.radius) {
                searchDispatch({
                    type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                    payload: {
                        radius: ""
                    }
                });
            }
        }
    };
    const updateCompanyInput = (changes)=>{
        const { inputValue , selectedItem , type  } = changes;
        // reset button was clicked with menu open
        const resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        const resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        const inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        searchDispatch({
            type: searchContextInterfaces/* CompanyActionTypes.updateCompany */.iW.updateCompany,
            payload: {
                userInputValue: inputValue,
                userSelectedCompany: selectedItem
            }
        });
        if (selectedItem) {
            searchDispatch({
                type: searchContextInterfaces/* FiltersActionTypes.updateFilter */.bL.updateFilter,
                payload: {
                    industry: [],
                    perks: [],
                    companySize: []
                }
            });
        }
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            searchDispatch({
                type: searchContextInterfaces/* CompanyActionTypes.updateCompany */.iW.updateCompany,
                payload: {
                    userInputValue: inputValue,
                    userSelectedCompany: null
                }
            });
        }
    };
    const updateKeywordInput = (changes)=>{
        const { inputValue , selectedItem , type  } = changes;
        // reset button was clicked with menu open
        const resetClickedMenuOpen = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionReset */.Kb.stateChangeTypes.FunctionReset;
        // reset button was clicked with menu closed
        const resetClickedMenuClosed = type === downshift_esm/* useCombobox.stateChangeTypes.FunctionOpenMenu */.Kb.stateChangeTypes.FunctionOpenMenu;
        // input was cleared from input field
        const inputValueCleared = type === downshift_esm/* useCombobox.stateChangeTypes.InputChange */.Kb.stateChangeTypes.InputChange && inputValue === "";
        // New keyword implementation
        searchDispatch({
            type: searchContextInterfaces/* KeywordActionTypes.updateKeyword */.l0.updateKeyword,
            payload: {
                userInputValue: inputValue,
                userSelectedKeyword: selectedItem
            }
        });
        if (resetClickedMenuOpen || resetClickedMenuClosed || inputValueCleared) {
            searchDispatch({
                type: searchContextInterfaces/* KeywordActionTypes.updateKeyword */.l0.updateKeyword,
                payload: {
                    userInputValue: inputValue,
                    userSelectedKeyword: null
                }
            });
        }
    };
    const onSearchButtonClick = ()=>{
        if (!(0,browser/* isMobile */.tq)()) {
            searchDispatch({
                type: searchContextInterfaces/* UserInteractionActionTypes.updateFilterInteraction */.lj.updateFilterInteraction,
                payload: {
                    searchButtonClickedAt: Date.now()
                }
            });
        }
    };
    const formStyles = (SearchInput_module_default()).form;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        className: formStyles,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_KeywordSearchInput, {
                    keyword: searchState.keyword,
                    clear: clearInputs,
                    onClear: clearValues,
                    onInputChange: updateKeywordInput,
                    noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResultsKeyword, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_CompanySearchInput, {
                company: searchState.company,
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateCompanyInput,
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_LocationSearchInput, {
                clear: clearInputs,
                onClear: clearValues,
                onInputChange: updateLocationInput,
                location: {
                    ...searchState.location,
                    locationSuggestions: locationSuggestionsSelector(searchState.location)
                },
                noResultsMessage: /*#__PURE__*/ (0,jsx_runtime.jsx)(NoResults, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchButton, {
                onClick: onSearchButtonClick
            })
        ]
    });
};
SearchInput.displayName = "SearchInput";
/* harmony default export */ var header_SearchInput = (SearchInput);

// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/IconFilter.tsx
var IconFilter = __webpack_require__(4073);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/Search.tsx
var Search = __webpack_require__(4940);
// EXTERNAL MODULE: ./src/components/toggle/SearchFilterToggleBar.module.scss
var SearchFilterToggleBar_module = __webpack_require__(9793);
var SearchFilterToggleBar_module_default = /*#__PURE__*/__webpack_require__.n(SearchFilterToggleBar_module);
;// CONCATENATED MODULE: ./src/components/toggle/SearchFilterToggleBar.tsx









const SearchFilterToggleBar = (props)=>{
    const { onToggle , open  } = props;
    const { filters , location  } = (0,SearchContext/* useSearchState */.XN)();
    const { searchHistory  } = useSearchHistory();
    const selectedValuesCount = getSelectedFiltersCount(filters, location?.userSelectedLocation?.remote_work_location_type);
    const filterButtonOnClick = ()=>{
        onToggle(!open);
        if ((0,browser/* isMobile */.tq)()) {
            (0,browser/* toggleWindowFreeze */.LF)();
        }
    };
    const filterText = selectedValuesCount ? `Edit Filters  (${selectedValuesCount})` : "Edit Filters";
    const searchesText = searchHistory.length ? `Recent Searches (${searchHistory.length})` : "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (SearchFilterToggleBar_module_default()).container,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
            className: (SearchFilterToggleBar_module_default()).filterBtn,
            color: "white",
            onClick: filterButtonOnClick,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFilter/* default */.Z, {
                    className: (SearchFilterToggleBar_module_default()).filterBtnIcon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    textStyle: "sans-serif-body-small",
                    className: (SearchFilterToggleBar_module_default()).filterBtnText,
                    children: filterText
                }),
                searchesText ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: " | "
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* default */.Z, {
                            className: (SearchFilterToggleBar_module_default()).filterBtnIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            textStyle: "sans-serif-body-small",
                            className: (SearchFilterToggleBar_module_default()).filterBtnText,
                            children: searchesText
                        })
                    ]
                }) : null
            ]
        })
    });
};
/* harmony default export */ var toggle_SearchFilterToggleBar = (SearchFilterToggleBar);

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/deep-equal/index.js
var deep_equal = __webpack_require__(251);
var deep_equal_default = /*#__PURE__*/__webpack_require__.n(deep_equal);
// EXTERNAL MODULE: ./src/utils/reducers.ts
var reducers = __webpack_require__(5823);
;// CONCATENATED MODULE: ./src/utils/searchResults.ts

/**
 * Convert an array to a string with commas.
 */ const joinIfArray = (prop)=>Array.isArray(prop) ? prop.join(",") : prop;
/**
 * Collect the params from both the user inputs and the existing query string.
 * With User params taking precedents.
 * We do not collect the cursor as that is a special circumstance
 */ const getParams = ({ filters , companyShortName , searchKeyword , remoteOption , latlng , cursor , searchApiPreference , limit =20  })=>{
    const inputParams = {
        query: searchKeyword,
        company_short_name: companyShortName,
        level: joinIfArray(filters?.experienceLevel),
        employee_range: joinIfArray(filters?.companySize),
        latlng,
        remote_work_location_type: remoteOption,
        company_industry: joinIfArray(filters?.industry),
        perks_and_benefits: joinIfArray(filters?.perks),
        category: joinIfArray(filters?.category),
        radius: latlng ? filters?.radius : null,
        posted_date_range: filters?.postedDateRange,
        company_leadership_attributes: joinIfArray(filters?.companyLeadership),
        preference: searchApiPreference,
        limit
    };
    // This should really not be here, we need to read this into state properly
    // const queryParams = parseQueryParamsToObject(window.location.search);
    const userParams = (0,reducers/* removeFalsy */.S)(inputParams);
    return {
        start_after: cursor,
        ...userParams
    };
};

// EXTERNAL MODULE: ./src/orm/jobs.ts
var jobs = __webpack_require__(2919);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/hooks/useJobAlertHistory/useJobAlertHistory.tsx + 1 modules
var useJobAlertHistory = __webpack_require__(1818);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/IconBell.tsx
var IconBell = __webpack_require__(5945);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Modals/Modal.tsx
var Modal = __webpack_require__(2869);
// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/JobAlertsContextual/JobAlertsContextual.tsx + 3 modules
var JobAlertsContextual = __webpack_require__(2645);
// EXTERNAL MODULE: ./src/components/content/Modals/JobAlertsModal.module.scss
var JobAlertsModal_module = __webpack_require__(9413);
var JobAlertsModal_module_default = /*#__PURE__*/__webpack_require__.n(JobAlertsModal_module);
;// CONCATENATED MODULE: ./src/components/content/Modals/JobAlertsModal.tsx







const JobAlertsModal = ({ filterProps , isOpen , onSubscribed =()=>{} , setIsOpen  })=>{
    const contentRef = (0,react.useRef)(null);
    const prevOpen = (0,react.useRef)(isOpen);
    const { 0: isSuccess , 1: setIsSuccess  } = (0,react.useState)(false);
    const { locationValue , modalActionProps  } = (0,react.useMemo)(()=>{
        const location = filterProps.location === "Remote / Flexible" ? "Flexible / Remote" : filterProps.location || null;
        return {
            locationValue: location,
            modalActionProps: {
                sp_modal_type: "job_alert",
                sp_modal_action_type: "submit",
                sp_modal_job_category: filterProps.category || null,
                sp_modal_job_location: location,
                sp_modal_newsletter_opt_in: null,
                sp_modal_screen_order: null,
                sp_modal_screen_name: null
            }
        };
    }, [
        filterProps.category,
        filterProps.location
    ]);
    const categoryLabel = (0,react.useMemo)(()=>{
        const { category  } = filterProps;
        return searchFacetItems/* jobCategoryItems.find */.Y0.find((x)=>x.value === category)?.label || category;
    }, [
        filterProps.category
    ]);
    const handleFormSubmit = (0,react.useCallback)((formData)=>{
        /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ const { special , ...filters } = filterProps;
        const apiData = {
            page_section: "search",
            ...filters,
            location: locationValue,
            ...formData
        };
        return (0,api/* jobAlertsSubscribeRequest */.Ml)(apiData);
    }, [
        filterProps,
        locationValue
    ]);
    const handleFormSuccess = (0,react.useCallback)((formData)=>{
        setIsSuccess(true);
        onSubscribed(formData);
        (0,snowplow_js_client_build.triggerSnowplowModalActionEvent)({
            ...modalActionProps,
            sp_modal_newsletter_opt_in: formData?.newsletter
        });
    }, [
        modalActionProps,
        onSubscribed
    ]);
    const handleFormError = (0,react.useCallback)(()=>{
        (0,snowplow_js_client_build.triggerSnowplowModalActionEvent)({
            ...modalActionProps,
            sp_modal_error_type: "Job Alerts subscription was unsuccessful."
        });
    }, [
        modalActionProps
    ]);
    (0,react.useEffect)(()=>{
        if (!isOpen && prevOpen.current) {
            (0,snowplow_js_client_build.triggerSnowplowModalActionEvent)({
                ...modalActionProps,
                sp_modal_action_type: "close"
            });
        }
        if (isOpen && !prevOpen.current) {
            (0,snowplow_js_client_build.triggerSnowplowImpressionEvent)(contentRef.current);
        }
        prevOpen.current = isOpen;
    }, [
        isOpen,
        modalActionProps
    ]);
    (0,react.useEffect)(()=>{
        if (isSuccess) {
            (0,snowplow_js_client_build.triggerSnowplowImpressionEvent)(contentRef.current);
        }
    }, [
        isSuccess
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        containerClassName: (JobAlertsModal_module_default()).container,
        contentClassName: (JobAlertsModal_module_default()).content,
        isOpen: isOpen,
        label: "Job Alerts",
        setIsOpen: setIsOpen,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            "data-tracking-props": JSON.stringify({
                sp_impression_component: "modal",
                sp_impression_modal_type: isSuccess ? "job_alert_success" : "job_alert",
                sp_impression_position: "pop_up"
            }),
            ref: contentRef,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsContextual/* default */.Z, {
                filterProps: {
                    ...filterProps,
                    category: categoryLabel
                },
                onFormError: handleFormError,
                onFormSubmit: handleFormSubmit,
                onFormSuccess: handleFormSuccess
            })
        })
    });
};
JobAlertsModal.displayName = "JobAlertsModal";

;// CONCATENATED MODULE: ./src/components/content/Modals/index.ts


// EXTERNAL MODULE: ./src/components/content/SearchHeader/AlertCTA.module.scss
var AlertCTA_module = __webpack_require__(7614);
var AlertCTA_module_default = /*#__PURE__*/__webpack_require__.n(AlertCTA_module);
;// CONCATENATED MODULE: ./src/components/content/SearchHeader/AlertCTA.tsx







const AlertCTA = ({ category , company , keyword , level , location  })=>{
    const { filterKey , filterProps  } = (0,react.useMemo)(()=>{
        if ([
            category,
            keyword,
            level,
            location
        ].every((s)=>!s) || company) {
            return {
                filterKey: "empty",
                filterProps: null
            };
        }
        const props = Object.entries({
            category,
            keyword,
            level,
            location
        }).reduce((accum, [key, value])=>{
            if (value) {
                return {
                    ...accum,
                    [key]: value
                };
            }
            return accum;
        }, {});
        return {
            filterKey: new URLSearchParams(props).toString(),
            filterProps: props
        };
    }, [
        category,
        company,
        keyword,
        level,
        location
    ]);
    const { append , hasAlert  } = (0,useJobAlertHistory/* default */.Z)(filterProps);
    const { 0: modalOpen , 1: setModalOpen  } = (0,react.useState)(false);
    const handleSubscribed = (0,react.useCallback)(()=>{
        append(filterProps);
    }, [
        append,
        filterProps
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
                className: classnames_default()((AlertCTA_module_default()).alertCTA, {
                    [(AlertCTA_module_default()).alertCTAHidden]: !filterProps
                }),
                color: "light-blue",
                "data-testid": "alert-cta__button",
                disabled: hasAlert || !filterProps,
                onClick: ()=>setModalOpen(true),
                children: [
                    "Set Job Alert",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBell/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(JobAlertsModal, {
                filterProps: filterProps || {},
                isOpen: modalOpen,
                onSubscribed: handleSubscribed,
                setIsOpen: setModalOpen
            }, filterKey)
        ]
    });
};

// EXTERNAL MODULE: ./src/components/content/SearchHeader/Heading.module.scss
var Heading_module = __webpack_require__(8635);
var Heading_module_default = /*#__PURE__*/__webpack_require__.n(Heading_module);
;// CONCATENATED MODULE: ./src/components/content/SearchHeader/Heading.tsx




const Heading = (props)=>{
    const { location , keyword , company , category , state  } = props;
    const total = state.totalCount;
    const headerStringObj = (0,strings/* getSearchSeoTitle */.Y8)(location, (0,strings/* unSlugify */.A$)(keyword), company, category, total);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
        className: (Heading_module_default()).total,
        "data-testid": "search-heading",
        children: [
            total > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: headerStringObj.totalString
            }),
            headerStringObj.suffix
        ]
    });
};
Heading.displayName = "Heading";

// EXTERNAL MODULE: ./src/components/content/SearchHeader/SearchHeader.module.scss
var SearchHeader_module = __webpack_require__(3172);
var SearchHeader_module_default = /*#__PURE__*/__webpack_require__.n(SearchHeader_module);
;// CONCATENATED MODULE: ./src/components/content/SearchHeader/SearchHeader.tsx





const SearchHeader = (props)=>{
    /* eslint-disable-next-line @typescript-eslint/no-unused-vars */ const { state , ...alertProps } = props;
    const { FEATURE_FLAG_JOB_ALERTS  } = useFeatureFlagsState();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SearchHeader_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                ...props
            }),
            !!FEATURE_FLAG_JOB_ALERTS && /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertCTA, {
                ...alertProps
            })
        ]
    });
};
SearchHeader.displayName = "SearchHeader";

;// CONCATENATED MODULE: ./src/components/content/SearchHeader/index.ts


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Icons/ArrowDownShape.tsx
var ArrowDownShape = __webpack_require__(8053);
// EXTERNAL MODULE: ./src/components/content/LoadMore.module.scss
var LoadMore_module = __webpack_require__(7686);
var LoadMore_module_default = /*#__PURE__*/__webpack_require__.n(LoadMore_module);
;// CONCATENATED MODULE: ./src/components/content/LoadMore.tsx




/**
 * Renders the load more button if there are in fact more results to get.
 */ const LoadMore = (params)=>{
    const { cb  } = params;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SquareButton/* default */.Z, {
        className: (LoadMore_module_default()).loadMore,
        color: "secondary-100",
        onClick: cb,
        children: [
            "Load More Results",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownShape/* default */.Z, {})
        ]
    });
};
LoadMore.displayName = "LoadMore";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/JobCard.tsx + 1 modules
var JobCard = __webpack_require__(9177);
;// CONCATENATED MODULE: ./src/utils/cookies.ts
// These only work inside the browser

/**
 * Retrieve an existing cookie or an empty string.
 */ const get = (name)=>{
    const r = document.cookie.match(`\\b${name}=([^;]*)\\b`);
    return r ? r[1] : "";
};
/**
 * Set a cookie or replace an existing cookie.
 */ const set = (name, value, days = 0)=>{
    if (!(0,browser/* isBrowser */.jU)()) {
        return "";
    }
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value};expires=${expires};path=/`;
    return document.cookie;
};
/**
 * Delete an existing cookie. (named remove due to delete being a reserved word)
 */ const remove = (name)=>{
    set(name, "", -1);
};
const Cookies = {
    remove,
    get,
    set
};
/* harmony default export */ var cookies = (Cookies);

;// CONCATENATED MODULE: ./src/utils/externalJobApply.ts


const cookieKey = "external_job_ids_list";
/**
 * Retrieve and decode the job object from the cookie.
 */ const getJobObject = ()=>{
    const cookie = cookies.get(cookieKey);
    const decodedData = window.atob(cookie.toString());
    const jobObject = JSON.parse(decodedData || "{}");
    return jobObject;
};
/**
 * Inject a new job ID and dedupe the list.
 */ const updateJobList = (list, id)=>{
    list.push(id);
    const newList = list.filter((x, index)=>list.indexOf(x) === index);
    return newList;
};
/**
 * Creat or update the jobs object.
 */ const setJobObject = (companyId, jobId)=>{
    const jobObject = getJobObject();
    jobObject[companyId] = jobObject[companyId] ? updateJobList(jobObject[companyId], jobId) : [
        jobId
    ];
    const encryptedJobs = window.btoa(JSON.stringify(jobObject));
    return encryptedJobs;
};
/**
 * Sets a cookie with the encrypted companies and jobs applied to by this session within the last 30 days.
 */ const externalJobApply = (companyId, jobId)=>{
    if (!browser/* isBrowser */.jU) {
        return;
    }
    const jobObject = setJobObject(companyId, jobId);
    cookies.set(cookieKey, jobObject, 30);
};


;// CONCATENATED MODULE: ./src/components/content/JobTile.tsx

/* eslint-disable camelcase */ 






/**
 * Attempt to pull the closest matching location out of the job.
 */ const getJobTileLocation = (props)=>{
    const { inputDma , locationType , locations , sessionDma  } = props;
    const isRemote = locationType === "virtual";
    // We always prefer the dropdown if it was used.
    const userLocation = inputDma || sessionDma;
    // We Only care about the actual location address and fallback to country.
    // eslint-disable-next-line max-len
    const locationStrings = locations.map((x)=>!/\w/.test(x.address) ? x.country.toUpperCase() : x.address);
    // This is the fully matched location (city and state).
    const matchedLocation = locationStrings.find((loc)=>loc === userLocation);
    // We may need to match only on the last segment of the location.
    const getState = (txt)=>{
        if (typeof txt === "string") {
            return txt.split(",")[1]?.trim()?.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    const matchedRegion = locationStrings.find((address)=>getState(address) === getState(userLocation));
    // First location in the list (fall back)
    const firstLocation = locationStrings[0];
    // The location to display
    const displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    const locationWord = ` location${locationStrings.length > 2 ? "s" : ""}`;
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    const extraLocations = locationStrings.length > 1 ? ` + ${locationStrings.length - 1}${locationWord}` : "";
    // If we are remote and there is a location we will separate them with a slash.
    const separator = displayLocation ? " / " : "";
    // Build the remote string.
    const remoteString = isRemote ? `${separator}Remote` : "";
    // all together now...
    return [
        `${displayLocation}${remoteString}${extraLocations}`
    ];
};
/**
 * Generate the job apply link.
 */ const getJobTileApplyUrl = (job)=>{
    const { apply_type , company: urlCompany , legacy_id , short_title  } = job;
    const { short_name  } = urlCompany;
    return apply_type === "external" ? `/job/redirect/${legacy_id}` : `/jobs/${short_name}/${short_title}#apply-inline-form`;
};
/**
 * Generates the tracking props for a card.
 * Returns an object.
 */ const getTrackingProps = (job, viewJobHref, total, index, searchId)=>({
        ...(0,tracking/* genJobTrackingProps */.iR)(job),
        link_href: viewJobHref,
        total_results_on_page: total,
        placement: "search_results",
        order_num: index + 1,
        sp_tile_order: index + 1,
        sp_tile_search_id: searchId,
        sp_impression_search_id: searchId
    });
/**
 * Generates a callback for the card click.
 * Returns a function.
 */ const generateHandleCardClick = (props, snowplowEventProps)=>(event)=>{
        const { viewJobHref , trackingProps , cb  } = props;
        // Only fire on clicking non anchor elements
        if (!(event.target instanceof HTMLAnchorElement) && !(event.target instanceof HTMLButtonElement)) {
            window.open(viewJobHref, "_blank");
            cb("Job Tile Clicked", {
                ...trackingProps,
                click_type: "view_job_tile"
            });
            (0,snowplow_js_client_build.triggerSnowplowClickEvent)(snowplowEventProps);
        }
    };
/**
 * Generates a callback for the car right click.
 * Returns a function.
 */ const generateHandleCardRightClick = (props)=>(event)=>{
        const { trackingProps , cb  } = props;
        // Only fire on clicking non anchor elements
        if (!(event.target instanceof HTMLAnchorElement) && !(event.target instanceof HTMLButtonElement)) {
            cb("Job Tile Clicked", {
                ...trackingProps,
                click_type: "view_job_tile"
            });
        }
    };
/**
 * Generates a callback for the company name click.
 * Returns a function.
 */ const generateHandleCompanyNameClick = (props)=>()=>{
        const { cb , trackingProps  } = props;
        cb("Job Tile Clicked", {
            ...trackingProps,
            click_type: "company_name_profile"
        });
    };
/**
 * Generates a callback for the view job click.
 * Returns a function.
 */ const generateHandleViewJobClick = (props, snowplowEventProps)=>{
    const { cb , trackingProps  } = props;
    return ()=>{
        cb("Job Tile Clicked", {
            ...trackingProps,
            click_type: "view_job_button"
        });
        (0,snowplow_js_client_build.triggerSnowplowClickEvent)(snowplowEventProps);
    };
};
/**
 * Generates a callback for the apply now click.
 * Returns a function.
 */ const generateHandleApplyNowClick = (props, snowplowEventProps)=>{
    const { trackingProps , apply_type , total , cb  } = props;
    return ()=>{
        cb("Job Tile Clicked", {
            ...trackingProps,
            click_type: "apply_now_button"
        });
        cb("Job Apply Clicked", {
            ...trackingProps,
            job_type: apply_type,
            placement_position: "search results",
            total_results_on_page: total,
            click_type: "tile"
        });
        externalJobApply(trackingProps.company_id.toString(), trackingProps.job_id);
        if ((0,browser/* isBrowser */.jU)() && typeof window.ga !== "undefined") {
            window.ga("send", {
                hitType: "event",
                eventCategory: "ExternalJob",
                eventAction: "job_tile_apply",
                nonInteraction: true
            });
        }
        (0,snowplow_js_client_build.triggerSnowplowClickEvent)(snowplowEventProps);
    };
};
/**
 * Returns a fully formed and trackable job tile
 */ const JobTile = (props)=>{
    const { searchId  } = (0,SearchContext/* useSearchState */.XN)();
    const { job , index , inputDMA , userLocationDma , total , viewed =false , showLogo =false , viewedCallback  } = props;
    const { company: searchResultsCompany , apply_type , id , snowplow_id , legacy_id , locations , short_title , title , postedDate , remote_work_location_type  } = job.hit;
    const applyNowHref = getJobTileApplyUrl(job.hit);
    const companyHref = `/profiles/${searchResultsCompany.short_name}`;
    const viewJobHref = `/jobs/${searchResultsCompany.short_name}/${short_title}`;
    const trackingProps = getTrackingProps(job, viewJobHref, total, index, searchId);
    const tileLocation = getJobTileLocation({
        inputDma: inputDMA,
        locationType: remote_work_location_type,
        locations,
        sessionDma: userLocationDma
    });
    const snowplowTileContentProps = {
        sp_tile_type: "job",
        sp_tile_company_id: searchResultsCompany.legacy_id.toString(),
        sp_tile_entity_id: legacy_id.toString(),
        sp_tile_entity_uuid: snowplow_id || id,
        sp_tile_location: null,
        sp_tile_order: index + 1
    };
    const handleCardClick = generateHandleCardClick({
        viewJobHref,
        trackingProps,
        cb: tracking/* museTrack */.YU
    }, {
        sp_click_component: "tile",
        sp_click_component_tile_type: "job",
        sp_click_position: "main",
        sp_click_target_page_section: "job_detail",
        sp_click_search_id: searchId,
        ...snowplowTileContentProps
    });
    const handleCardRightClick = generateHandleCardRightClick({
        trackingProps,
        cb: tracking/* museTrack */.YU
    });
    const handleCompanyNameClick = generateHandleCompanyNameClick({
        trackingProps,
        cb: tracking/* museTrack */.YU
    });
    const handleViewJobClick = generateHandleViewJobClick({
        trackingProps,
        cb: tracking/* museTrack */.YU
    }, {
        sp_click_component: "button",
        sp_click_component_tile_type: "job",
        sp_click_button_type: "job_view",
        sp_click_position: "main",
        sp_click_target_page_section: "job_detail",
        sp_click_search_id: searchId,
        ...snowplowTileContentProps
    });
    // Apply on company site
    const handleApplyNowClick = generateHandleApplyNowClick({
        trackingProps,
        apply_type,
        total,
        cb: tracking/* museTrack */.YU
    }, {
        sp_click_component: "button",
        sp_click_component_tile_type: "job",
        sp_click_button_type: "apply",
        sp_click_position: "main",
        sp_click_target_page_section: "off_site",
        sp_click_search_id: searchId,
        ...snowplowTileContentProps
    });
    const jobCardProps = {
        showLogo,
        companyName: searchResultsCompany.name,
        companyLogo: searchResultsCompany.logo,
        jobName: title,
        locations: tileLocation,
        companyHref,
        applyNowHref,
        postedDate,
        viewJobHref,
        onApplyNowClick: handleApplyNowClick,
        onViewJobClick: handleViewJobClick,
        onCompanyNameClick: handleCompanyNameClick,
        onCardClick: handleCardClick,
        onViewJobRightClick: handleViewJobClick,
        onApplyNowRightClick: handleApplyNowClick,
        onCompanyNameRightClick: handleCompanyNameClick,
        onCardRightClick: handleCardRightClick,
        isLazy: index > 1
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tracking/* TrackedElement */.cg, {
        eventName: "Job Tile Viewed",
        eventProps: trackingProps,
        enabled: !viewed,
        callback: viewedCallback,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobCard/* default */.Z, {
            ...jobCardProps
        }, `card-${id}`)
    }, `tracked-${id}`);
};
JobTile.displayName = "JobTile";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/components/Cards/EmptyResult.tsx + 1 modules
var EmptyResult = __webpack_require__(5933);
// EXTERNAL MODULE: ./src/components/content/Empty.module.scss
var Empty_module = __webpack_require__(752);
var Empty_module_default = /*#__PURE__*/__webpack_require__.n(Empty_module);
;// CONCATENATED MODULE: ./src/components/content/Empty.tsx



/**
 * Uhho screen renders when there are zero results
 */ const Empty = (params)=>{
    const { requested , results , cb  } = params;
    return requested && !results ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Empty_module_default()).empty,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyResult/* default */.Z, {
            title: "Uh-oh.",
            details: "We couldn\u2019t find any jobs that match your search. Please try clearing all your filters, entering a new keyword, or searching in a different location.",
            buttonCta: "Clear my Search",
            onClick: cb
        })
    }) : null;
};
Empty.displayName = "Empty";


// EXTERNAL MODULE: ./src/components/content/SearchResults.module.scss
var SearchResults_module = __webpack_require__(235);
var SearchResults_module_default = /*#__PURE__*/__webpack_require__.n(SearchResults_module);
;// CONCATENATED MODULE: ./src/components/content/SearchResults.tsx

/* eslint-disable camelcase */ 


























const DynamicJobAlertWrapper = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(688), __webpack_require__.e(268)]).then(__webpack_require__.bind(__webpack_require__, 9116)).then((x)=>x.JobAlertWrapper), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(9116)
            ]
    },
    ssr: false
});
/**
 * Extract the closest matching location out of a job and format it for display in a job tile.
 */ const SearchResults_getJobTileLocation = (props)=>{
    const { inputDma , locationType , locations , sessionDma  } = props;
    const isRemote = locationType === "virtual";
    // We always prefer the dropdown if it was used.
    const userLocation = inputDma || sessionDma;
    // We Only care about the actual location address.
    const locationStrings = locations.map((location)=>location.address);
    // This is the fully matched location (city and state).
    const matchedLocation = locationStrings.filter((loc)=>loc === userLocation)[0];
    // We may need to match only on the last segment of the location.
    const getState = (txt)=>{
        if (typeof txt === "string") {
            return txt.split(",")[1]?.trim()?.toLowerCase();
        }
        return null;
    };
    // First location matched by region.
    const matchedRegion = locationStrings.filter((address)=>getState(address) === getState(userLocation))[0];
    // First location in the list (fall back)
    const firstLocation = locationStrings[0];
    // The location to display
    const displayLocation = matchedLocation || matchedRegion || firstLocation || "";
    // If we have more than 2 locations pluralize the string.
    const locationWord = ` location${locationStrings.length > 2 ? "s" : ""}`;
    // If we have more than 1 location we add a plus sign and the number plus the word location(s)
    const extraLocations = locationStrings.length > 1 ? ` + ${locationStrings.length - 1}${locationWord}` : "";
    // If we are remote and there is a location we will separate them with a slash.
    const separator = displayLocation ? " / " : "";
    // Build the remote string.
    const remoteString = isRemote ? `${separator}Remote` : "";
    // all together now...
    return [
        `${displayLocation}${remoteString}${extraLocations}`
    ];
};
/**
 * Renders a list of JobTile components based on the search results passed.
 */ const Tiles = /*#__PURE__*/ react.memo((props)=>{
    const { searchResults , locationName , userInteractions , userLocationDma , resultsLength , searchDispatch  } = props;
    const [jobAlertsViewed, setJobAlertsViewed] = react.useState(false);
    const { FEATURE_FLAG_JOBALERT_SEARCH  } = useFeatureFlagsState();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: searchResults.map((job, index)=>{
            const inputDMA = locationName ?? "";
            const viewed = userInteractions.tilesViewedJobIds.includes(job.hit.id);
            const show_logo = ![
                "archived",
                "lite"
            ].includes(job?.hit?.company?.client_tier ?? "");
            const handleViewedCallback = (jobId)=>{
                searchDispatch({
                    type: searchContextInterfaces/* UserInteractionActionTypes.updateJobTileViews */.lj.updateJobTileViews,
                    payload: {
                        tilesViewedJobIds: [
                            jobId
                        ]
                    }
                });
            };
            const enableJobAlert = index === 3 && FEATURE_FLAG_JOBALERT_SEARCH;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(JobTile, {
                        job,
                        index,
                        inputDMA,
                        userLocationDma,
                        total: resultsLength,
                        viewed,
                        showLogo: show_logo,
                        viewedCallback: ()=>handleViewedCallback(job.hit.id)
                    }),
                    enableJobAlert ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicJobAlertWrapper, {
                        jobAlertsViewed,
                        setJobAlertsViewed
                    }) : null
                ]
            }, `${job.hit.id}`);
        })
    });
});
Tiles.displayName = "Tiles";
/**
 * Render job search results and handling user interactions with the search results page.
 */ const SearchResults = (props)=>{
    const { onClear  } = props;
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    const { location: userLocation  } = (0,UserContext/* useUserState */.e)();
    const searchDispatch = (0,SearchContext/* useSearchDispatch */.bn)();
    const searchResultsState = useSearchResultsState();
    const { totalCount , results  } = searchResultsState;
    const searchResultsDispatch = useSearchResultsDispatch();
    const { ctsEnabled  } = (0,SearchContext/* useSearchState */.XN)();
    const [jobsHasBeenRequested, setJobsHasBeenRequested] = react.useState(false);
    const [userLocationDma, setUserLocationDma] = react.useState("");
    const [hasMore, setHasMore] = react.useState(false);
    const [classState, setClassState] = react.useState((SearchResults_module_default()).resultsGrid);
    const [initialLoad, setInitialLoad] = react.useState(true);
    const searchState = (0,SearchContext/* useSearchState */.XN)();
    const { company , location , keyword , filters , locationName , latitude , latlng , remoteOption , companyName , companyShortName , category , searchKeyword , userInteractions , url , preference , searchId  } = searchResultsSelector(searchState);
    // eslint-disable-next-line arrow-body-style
    const jobLevel = react.useMemo(()=>{
        return filters?.experienceLevel?.filter(Boolean)?.shift()?.split(",")?.shift() ?? "";
    }, [
        filters?.experienceLevel
    ]);
    const [searchRequestState, setSearchRequestState] = react.useState({
        filters,
        companyShortName,
        searchKeyword,
        remoteOption,
        latlng,
        searchId
    });
    (0,useDebounce/* default */.Z)(()=>{
        // Handle any updated search params
        const updatedSearchRequestState = {
            filters,
            companyShortName,
            searchKeyword,
            remoteOption,
            latlng,
            searchId
        };
        if (!deep_equal_default()(updatedSearchRequestState, searchRequestState)) {
            setSearchRequestState(updatedSearchRequestState);
        }
    }, 500, [
        company,
        location,
        keyword,
        filters
    ]);
    const router = (0,next_router.useRouter)() || {
        asPath: ""
    };
    const { asPath  } = router;
    // This is the search id we want to use for tracking
    let uniqueSearchId = searchId;
    react.useEffect(()=>{
        if (!(initialLoad && !!searchId)) {
            uniqueSearchId = (0,v4/* default */.Z)();
            searchDispatch({
                type: searchContextInterfaces/* SearchIdActionTypes.updateSearchId */._L.updateSearchId,
                payload: uniqueSearchId
            });
        }
    }, [
        searchRequestState
    ]);
    react.useEffect(()=>{
        // We load the first set of search results server
        // side, so we don't want to fetch on initial load.
        if (!initialLoad || !results.length) {
            const urlPath = (0,browser/* generateUrlPath */.lT)({
                companyShortName,
                locationName: (0,strings/* normalizeLocationName */.DU)(locationName),
                searchKeyword,
                filters,
                asPath
            });
            fetchJobSearchResults();
            searchDispatch({
                type: searchContextInterfaces/* UrlActionTypes.updateUrl */.qB.updateUrl,
                payload: urlPath
            });
        }
        const searchEventProps = {
            sp_search_type: "job",
            sp_search_id: uniqueSearchId,
            sp_search_keyword: searchKeyword
        };
        const isRemote = remoteOption === "virtual";
        const snowplowFilters = buildSnowplowFilterItems(filters, locationName, companyShortName);
        (0,snowplow_js_client_build.triggerSnowplowSearchEvent)(searchEventProps, snowplowFilters, isRemote);
    }, [
        searchRequestState,
        userInteractions?.searchButtonClickedAt
    ]);
    react.useEffect(()=>{
        setHasMore(!!(totalCount - results.length));
    }, [
        totalCount,
        results.length
    ]);
    /**
     * Fetch jobs with an optional cursor Id.
     *
     * @param cursor This is the cursor within the last job on the page.
     * @returns Promise
     */ const fetchJobSearchResults = async (cursor)=>{
        setJobsHasBeenRequested(true);
        // if this is not a load more request and we are scrolled at all, snap back to the top.
        if (!cursor && window.scrollY) {
            window.scrollTo(0, 0);
        }
        const queryParams = getParams({
            filters,
            companyShortName,
            searchKeyword,
            remoteOption,
            latlng,
            cursor,
            searchApiPreference: preference
        });
        const jobsResponse = await (0,api/* fetchJobs */.bG)(queryParams, ctsEnabled);
        const dispatchValues = (0,jobs/* formatJobsResponse */.n)(jobsResponse);
        const update = cursor ? [
            ...searchResultsState.results,
            ...dispatchValues.results
        ] : [
            ...dispatchValues.results
        ];
        searchResultsDispatch({
            type: "update_results",
            payload: {
                values: {
                    ...dispatchValues,
                    results: update
                }
            }
        });
        setJobsHasBeenRequested(false);
    };
    /**
     * Clear all the search filters
     */ const clearSearch = ()=>{
        searchDispatch({
            type: searchContextInterfaces/* FiltersActionTypes.resetAllFilters */.bL.resetAllFilters
        });
        searchDispatch({
            type: searchContextInterfaces/* CompanyActionTypes.resetCompany */.iW.resetCompany
        });
        searchDispatch({
            type: searchContextInterfaces/* LocationActionTypes.resetLocation */.B3.resetLocation
        });
        searchDispatch({
            type: searchContextInterfaces/* KeywordActionTypes.resetKeyword */.l0.resetKeyword
        });
        onClear?.();
    };
    /**
     * This is the event fired by the load more button.
     * @param event:  The click event.
     */ const handleLoadMoreClick = react.useCallback((event)=>{
        if (event) {
            event.preventDefault();
        }
        fetchJobSearchResults(searchResultsState.cursor);
    }, [
        searchResultsState.cursor
    ]);
    /**
     * setUserLocationDma are triggered when any of the following are modified:
     * userInputs location lat changes
     */ react.useEffect(()=>{
        setUserLocationDma(userLocation?.dma);
    }, [
        latitude
    ]);
    /**
     * Push a new history state only after filter changes
     */ react.useEffect(()=>{
        if (typeof url !== "undefined") {
            window.history.pushState(null, null, `${url}${window.location.search}`);
        }
    }, [
        url
    ]);
    react.useEffect(()=>{
        const classes = classnames_default()(hasMore ? (SearchResults_module_default()).hasFade : false, (SearchResults_module_default()).resultsGrid);
        const shimmer = jobsHasBeenRequested ? (SearchResults_module_default()).shimmer : null;
        setClassState(classnames_default()(shimmer, classes));
    }, [
        hasMore,
        jobsHasBeenRequested
    ]);
    const searchResults = searchResultsState.results ?? [];
    const resultsLength = searchResults.length ?? 0;
    const getLDJson = (list)=>{
        const itemListElement = list.map((job, index)=>{
            const { apply_type , short_title  } = job?.hit ?? {};
            const extension = apply_type === "external" ? "" : "#apply-inline-form";
            return {
                "@type": "ListItem",
                position: index + 1,
                url: `${museWebHost}/jobs/${job?.hit?.company?.short_name}/${short_title}${extension}`
            };
        });
        return JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            itemListElement
        });
    };
    const tilesProps = {
        searchResults,
        locationName,
        userInteractions,
        userLocationDma,
        resultsLength,
        searchDispatch
    };
    react.useEffect(()=>{
        if (initialLoad) {
            setInitialLoad(false);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchHeader, {
                category: category,
                company: companyName ?? null,
                keyword: searchKeyword ?? null,
                level: jobLevel,
                location: locationName ?? null,
                state: searchResultsState
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    // using old style script and head so that this script will update on filter change.
                    type: "application/ld+json",
                    id: "ItemList",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: getLDJson(searchResults)
                    }
                })
            }),
            resultsLength ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classState,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tiles, {
                        ...tilesProps
                    }),
                    hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadMore, {
                        cb: handleLoadMoreClick
                    }) : null
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Empty, {
                requested: jobsHasBeenRequested,
                results: resultsLength,
                cb: clearSearch
            })
        ]
    });
};
SearchResults.displayName = "SearchResults";


// EXTERNAL MODULE: ./node_modules/@themuse/design-system/lib/utils/string.js
var string = __webpack_require__(8340);
;// CONCATENATED MODULE: ./src/utils/titleNormalization.ts
/* eslint-disable quote-props */ // Direct trade B for A.
const replacers = {
    "assoc. ": "Associate",
    "assoc ": "Associate",
    "mgr. ": "Manager",
    "mgr ": "Manager",
    "part-time": "part time",
    "full-time": "full time",
    "sr.": "Senior",
    "jr.": "Junior"
};
// Completely remove.
const individualChars = [
    "sign on",
    "sign-on",
    "bonus",
    '"',
    "/",
    "*",
    "!",
    "%",
    "&",
    "+",
    ":",
    "$",
    "#",
    "|",
    "@",
    " . "
];
// Completely remove plus anything after.
const removeAfterChars = [
    " at ",
    " per hour ",
    " in ",
    " -",
    "(",
    "[",
    "{",
    "\\",
    ";",
    " | ",
    ",",
    "- "
];
/**
 * Escape characters for special string regex.
 */ const titleNormalization_escape = (x)=>x.replace(/[-[\]{}()/*+?.,\\^$|#\s]/g, "\\$&");
/**
 * Encode then double decode to remove any special characters
 */ const removeEncoding = (title)=>{
    let result = decodeURIComponent(encodeURIComponent(title));
    try {
        result = decodeURIComponent(result);
    } catch (e) {
    // do nothing its not encoded.
    }
    return result;
};
/**
 * Remove all HTML tags
 */ const removeHTML = (title)=>title.replace(/(<([^>]+)>)/ig, "").trim();
/**
 * Remove strings wrapped in braces.
 */ const removeBraceWrapped = (title)=>title.replace(/\{.+?\}/ig, "").trim();
/**
 * Remove strings wrapped in brackets.
 */ const removeBracketWrapped = (title)=>title.replace(/\[.+?\]/ig, "").trim();
/**
 * Remove strings wrapped in parentheses.
 */ const removeParenthesesWrapped = (title)=>title.replace(/\(.+?\)/ig, "").trim();
/**
 * Assume this character / string and everything after it is junk.
 */ const removeAfter = (title)=>removeAfterChars.reduce((prev, curr)=>{
        const re = new RegExp(titleNormalization_escape(curr), "ig");
        return prev.split(re)[0];
    }, title);
/**
 * Replace specific characters or phrases.
 */ const replaceMap = (title)=>Object.keys(replacers).reduce((prev, curr)=>{
        const re = new RegExp(titleNormalization_escape(curr), "ig");
        return prev.replace(re, replacers[curr]);
    }, title);
/**
 * Replace individual groupings with a space.
 */ const removeIndividual = (title)=>individualChars.reduce((prev, curr)=>{
        const re = new RegExp(titleNormalization_escape(curr), "ig");
        return prev.replace(re, " ");
    }, title);
/**
 * Remove roman numerals.
 */ const removeRomanNumerals = (title)=>title.replace(/\b(VI|V|IV|III|II|I)\b/, " ");
/**
 * Remove html encoded entities.
 */ const removeHtmlEntities = (title)=>title.replace(/&nbsp;|&apos;|&quot;|&gt;|&lt;|&amp;/ig, " ");
/**
 * Remove things that look like time.
 * * 0|01 - 24 hours
 * * followed by colon
 * * followed by 00-59
 * * followed by am or pm.
 */ const removeTime = (title)=>title.replace(/((?:\d|[01]\d|2[0-3]):[0-5]\d?([AP]M))/ig, " ");
/**
 * Remove strings that look like money.
 */ const removeMoney = (title)=>title.replace(/(\$?\d+,?\d+\.?\d+k?)|/ig, "");
/**
 * Removes anything at the end of the string that is not a letter.
 * Should be run last.
 */ const clearLastSymbol = (title)=>title.replace(/[^A-Z]+$/ig, "");
/**
 * Removes anything at the begining of the string that is a symbol.
 * Should be run last.
 */ const clearFirstSymbol = (title)=>title.replace(/^[\W_]+/ig, "");
/**
 * Removes leading standalone numbers followed by a space
 * Should be run in group 3.
 */ const clearLeadingNumbers = (title)=>title.replace(/^[\d\s-/]+\s/, "");
/**
 * Remove multiple whitespace characters including tab space linefeed backspace...
 */ const removeContiguousWhiteSpace = (title)=>title.replace(/\s+/g, " ").trim();
/**
 * Loop through each replacers, trimming after each pass.
 */ const titleNormalization = (title)=>{
    const starter = title.trim();
    const operations = [
        // # Round 1 Rules.  These cleanup the characters for the rest of the replacers.
        removeEncoding,
        removeHTML,
        removeHtmlEntities,
        removeBraceWrapped,
        removeBracketWrapped,
        removeParenthesesWrapped,
        // # Round 2 Rules.  These start removing huge chunks of text.
        replaceMap,
        removeMoney,
        removeTime,
        removeAfter,
        removeIndividual,
        removeRomanNumerals,
        // # Round 3 Rules.  These come near the end as numbers and such could get pushed to the edges.
        clearLastSymbol,
        clearFirstSymbol,
        clearLeadingNumbers,
        // # Round 4 Rule. Dead last to cleanup the whitespace.
        removeContiguousWhiteSpace, 
    ];
    const result = operations.reduce((prev, curr)=>curr.call(undefined, prev).trim(), starter);
    return result.trim();
};


// EXTERNAL MODULE: ./src/components/content/BrowseLinks.module.scss
var BrowseLinks_module = __webpack_require__(148);
var BrowseLinks_module_default = /*#__PURE__*/__webpack_require__.n(BrowseLinks_module);
;// CONCATENATED MODULE: ./src/components/content/BrowseLinks.tsx

/* eslint-disable camelcase */ 








/**
 * Convert a word to proper Case.
 */ const titleWordCase = (txt)=>`${txt.charAt(0).toUpperCase()}${txt.substr(1).toLowerCase()}`;
const regex = /([~!@#$%^&*\]){}_+\-(\s])/ig;
/**
 * Convert a sentence to proper Case.
 */ const titleCase = (txt)=>txt.split(regex).map(titleWordCase).join("");
/**
 * Generates a link to the browse state page for this job title.
 *
 * @returns {ReactElement}.
 */ const BrowseLinks = ()=>{
    const router = (0,next_router.useRouter)();
    const { asPath  } = router;
    const { publicRuntimeConfig: { museWebHost  }  } = (0,config["default"])();
    const { location: { userSelectedLocation  } , keyword: { userInputValue  }  } = (0,SearchContext/* useSearchState */.XN)();
    const { 0: relatedCities , 1: setRelatedCities  } = (0,react.useState)([]);
    const keyword = (0,string/* slugify */.lV)(titleNormalization(userInputValue)) || "";
    const state = (0,string/* slugify */.lV)(userSelectedLocation.label || "").split("-").pop() ?? "";
    const titleCaseKeyWord = titleCase(keyword.split("-").join(" "));
    const stateName = constants/* states.find */.$q.find((x)=>x[1] === state.toUpperCase())?.slice(0, 1) ?? "";
    (0,react.useEffect)(()=>{
        (0,api/* fetchJobTitleCities */.yZ)(keyword, state.toUpperCase()).then((x)=>setRelatedCities(x?.cities ?? [])).catch(console.error);
    }, [
        keyword,
        state
    ]);
    const href = `${museWebHost}/browse/job-titles/${keyword}/${state.toUpperCase()}`;
    if (!asPath.includes("/hiring") || !relatedCities?.length) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (BrowseLinks_module_default()).browserLinks,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: href,
            children: `${titleCaseKeyWord} Jobs in ${stateName}`
        })
    });
};
BrowseLinks.displayName = "BrowseLinks";


;// CONCATENATED MODULE: ./src/components/content/SearchPageLayout.tsx

/* eslint-disable camelcase */ 










const SearchPageLayout = ()=>{
    const user = (0,UserContext/* useUserState */.e)();
    const { addHistory  } = useSearchHistory();
    const pageLayoutProps = {
        activePath: "/search",
        headerClassName: (Home_module_default()).pageHeader,
        pageName: (Home_module_default()).pageWrapper,
        mainClassName: (Home_module_default()).main,
        showSubMenus: true,
        user
    };
    const [filterOpen, setFilterOpen] = react.useState(false);
    const [clearInputs, setClearInputs] = react.useState(false);
    const handleClose = ()=>{
        setFilterOpen(false);
    };
    const clearSearch = ()=>{
        setClearInputs(true);
        addHistory();
    };
    const inputsCleared = ()=>{
        setClearInputs(false);
        addHistory();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        ...pageLayoutProps,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchHistoryProvider, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (Home_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header_SearchInput, {
                            clearInputs: clearInputs,
                            onClear: inputsCleared
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: (Home_module_default()).filterToggle,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_SearchFilterToggleBar, {
                            open: filterOpen,
                            onToggle: (open)=>setFilterOpen(open)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("aside", {
                        className: classnames_default()((Home_module_default()).sidebar, filterOpen ? (Home_module_default()).showSidebar : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(facets_SearchFacets, {
                            onClose: handleClose,
                            onFiltersChange: ()=>undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                className: (Home_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResults, {
                        onClear: clearSearch
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BrowseLinks, {})
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/index.tsx


















/**
 * Convert the job level into an array of strings that the API can understand.
 */ const convertExperienceLevel = (level)=>{
    const result = level.split(",").map((levelValue)=>{
        if ([
            "senior",
            "management"
        ].includes(levelValue)) {
            return "senior,management";
        }
        return levelValue;
    });
    return [
        ...new Set(result)
    ];
};
/**
 * Convert the selected location into an array of strings that the API can understand.
 */ const convertSelectedLocation = (location)=>({
        label: location.label === "Flexible / Remote" ? "Remote / Flexible" : location.label,
        latitude: parseFloat(location.latitude),
        longitude: parseFloat(location.longitude),
        remote_work_location_type: location.label === "Remote / Flexible" || location.label === "Flexible / Remote" ? "virtual" : "",
        value: location.value === "Flexible / Remote" ? "Remote / Flexible" : location.value
    });
var __N_SSP = true;
const getInitialFilterParams = (params)=>Object.keys(params).reduce((values, currentValue)=>{
        const localValues = values;
        if (![
            "location",
            "company"
        ].includes(currentValue)) {
            const decodedParamValue = decodeURIComponent(params[currentValue]);
            // Format keyword
            let value = decodedParamValue;
            if (currentValue === "keyword") {
                value = (0,strings/* titleCase */.Qs)(value.replace(/\+/g, " "));
            }
            localValues[currentValue] = value;
        }
        return localValues;
    }, {});
const getInitialSearchId = (reqUrl, reqHost)=>{
    const parsedUrl = new URL(reqUrl || "", `http://${reqHost || "www.example.com"}`);
    const searchIdValue = parsedUrl.searchParams.get("_search_id");
    return searchIdValue || (0,v4/* default */.Z)();
};
const setInitialSearchState = (initialSearchParams, companyAttributes, initialDropDownCompanies, ctsEnabled)=>{
    const { location =null , company =null , keyword ="" , category ="" , industry ="" , level ="" , perks ="" , size ="" , radius ="" , "date-posted": postedDateRange = "" , "company-leadership": companyLeadership = "" , preference ="" , searchId =""  } = initialSearchParams;
    const { perks_and_benefits  } = companyAttributes;
    const experienceLevel = convertExperienceLevel(level);
    const radiusValues = getFacetValuesFromFacetItems(radius, searchFacetItems/* searchRadiusItems */.Z5);
    const initialRadius = location ? radiusValues[0] ?? "" : "";
    const postedDateRangeValues = getFacetValuesFromFacetItems(postedDateRange, searchFacetItems/* postedDateRangeItems */.dK);
    const initialPostedDateRange = postedDateRangeValues[0] ?? "";
    return {
        location: location ? {
            userInputValue: location.label,
            userSelectedLocation: convertSelectedLocation(location)
        } : {
            userInputValue: "",
            // we are not using the users location on the server.
            userSelectedLocation: {
                label: "",
                latitude: null,
                longitude: null,
                value: ""
            }
        },
        company: company ? {
            userSelectedCompany: {
                label: company.name,
                value: company.shortname
            },
            companySuggestions: initialDropDownCompanies
        } : {},
        keyword: {
            userInputValue: keyword || "",
            userSelectedKeyword: {
                label: keyword || "",
                value: keyword || ""
            }
        },
        filters: {
            experienceLevel,
            category: getFacetValuesFromFacetItems(category, searchFacetItems/* jobCategoryItems */.Y0),
            industry: getFacetValuesFromFacetItems(industry, searchFacetItems/* companyIndustryItems */.fA),
            perks: getFacetValuesFromFacetItems(perks, (0,searchFacetItems/* flattenPerksAndBenefits */.sg)(perks_and_benefits)),
            companyLeadership: getFacetValuesFromFacetItems(companyLeadership, searchFacetItems/* diversityInclusionItems */.uq),
            companySize: size?.length ? decodeURIComponent(size).split(",") : [],
            radius: initialRadius,
            postedDateRange: initialPostedDateRange
        },
        preference,
        searchId,
        ctsEnabled
    };
};
const snowplowPageData = {
    sp_page_is_external: false,
    sp_page_section: "search",
    sp_page_sponsor_id: null,
    sp_page_tab: null,
    sp_page_type: "collection",
    sp_experiment_experiment_id: "",
    sp_experiment_variant_id: ""
};
/**
 * Initializes the Snowplow tracker and triggers page view events based on user actions and experiment data.
 */ const SnowplowInit = ()=>{
    const user = (0,UserContext/* useUserState */.e)();
    const { publicRuntimeConfig  } = (0,config["default"])();
    const { 0: pageViewTriggered , 1: setPageViewTriggered  } = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        const enabledVariant = (0,build.getActiveVariant)("RECENT_SEARCHES", // eslint-disable-next-line no-underscore-dangle
        window?.__NEXT_DATA__?.props?.pageProps?.experiments ?? []);
        const experimentData = enabledVariant ? {
            sp_experiment_experiment_id: "RECENT_SEARCHES",
            sp_experiment_variant_id: enabledVariant
        } : {};
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            ...snowplowPageData,
            ...experimentData
        });
        if (publicRuntimeConfig?.snowplowCollector) {
            (0,snowplow_js_client_build.initSnowplowTracker)(publicRuntimeConfig.snowplowCollector);
        }
    }, []);
    (0,react.useEffect)(()=>{
        window.sp_user_logged_in = user.logged_in ?? false;
        window.sp_user_id = user.id ?? null;
    }, [
        user
    ]);
    // Note: Add snowplow pageview in a useEffect??
    // After a user api request attempt has been made??
    (0,react.useEffect)(()=>{
        if (user.isInitialized && !pageViewTriggered) {
            (0,snowplow_js_client_build.triggerSnowplowPageViewEvent)();
            setPageViewTriggered(true);
        }
    }, [
        user
    ]);
    return null;
};
const UserInit = ()=>{
    const user = (0,UserContext/* useUserState */.e)();
    (0,react.useEffect)(()=>{
        // NOTE: An email with `themuse.com` does not mean the user is an admin
        const isMuser = user?.email && user.email.split("@")[1] === "themuse.com";
        (0,tracking/* userTrack */.Uk)({
            signed_in: user.logged_in ?? false,
            is_muser: isMuser,
            is_admin: isMuser,
            user_id: user.id ?? null
        });
    }, [
        user
    ]);
    return null;
};
const Home = (props)=>{
    const { carmenLocation , companyAttributes , featureFlags , initialSearchResultsState , initialSearchState ,  } = props;
    const router = (0,next_router.useRouter)();
    const { asPath  } = router;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserContext/* UserProvider */.d, {
        userLocation: carmenLocation,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureFlagsProvider, {
            featureFlags: featureFlags,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchFacetsProvider, {
                companyFacets: companyAttributes,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContext/* SearchProvider */.X$, {
                    ...initialSearchState,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SearchResultsProvider, {
                        ...initialSearchResultsState,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SnowplowInit, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInit, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo, {
                                searchUrl: asPath
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchPageLayout, {})
                        ]
                    })
                })
            })
        })
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 148:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"browserLinks":"BrowseLinks_browserLinks__Ax_xl"};

/***/ }),

/***/ 752:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"empty":"Empty_empty__FTeFV"};

/***/ }),

/***/ 7686:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loadMore":"LoadMore_loadMore__Gi4JP"};

/***/ }),

/***/ 9413:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"JobAlertsModal_container__o8oog","content":"JobAlertsModal_content__79ml_"};

/***/ }),

/***/ 7614:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"alertCTA":"AlertCTA_alertCTA__z_Q9u","alertCTAHidden":"AlertCTA_alertCTAHidden__V59jS"};

/***/ }),

/***/ 8635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"total":"Heading_total__11Z0e"};

/***/ }),

/***/ 3172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchHeader_wrapper__sd2ab"};

/***/ }),

/***/ 235:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"resultsGrid":"SearchResults_resultsGrid__pHY29","hasFade":"SearchResults_hasFade__KcoTL","shimmer":"SearchResults_shimmer__nbZ_7","shimmerKeyFrame":"SearchResults_shimmerKeyFrame__D3qN_"};

/***/ }),

/***/ 4744:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"RecentSearches":"RecentSearches_RecentSearches__tW91t","heading":"RecentSearches_heading__zj8M3","hidden":"RecentSearches_hidden__ZA14n","search":"RecentSearches_search__Ra09L","toolTipTwoColum":"RecentSearches_toolTipTwoColum___V96K","toolTipThreeColum":"RecentSearches_toolTipThreeColum__Lspjq","link":"RecentSearches_link__ygXhK","current":"RecentSearches_current__sfNGd","moreLess":"RecentSearches_moreLess__wT9t3"};

/***/ }),

/***/ 3223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFacets_container___Jc6E","header":"SearchFacets_header__6_Q7a","mainHeader":"SearchFacets_mainHeader__x0U55","facetWrapper":"SearchFacets_facetWrapper__w_VUB","headerText":"SearchFacets_headerText__zd1S_","subHeaderText":"SearchFacets_subHeaderText__F9Rmp","headerButton":"SearchFacets_headerButton__1SzQE","facet":"SearchFacets_facet__w8n_2","facetList":"SearchFacets_facetList__DuDK0","facetButton":"SearchFacets_facetButton___TFbI","footer":"SearchFacets_footer__AY6FW","clearFacets":"SearchFacets_clearFacets__zYutE","clearFacetsIcon":"SearchFacets_clearFacetsIcon__no2Lv","clearFacetsText":"SearchFacets_clearFacetsText__TCNDt","viewResults":"SearchFacets_viewResults__LRYx4"};

/***/ }),

/***/ 7334:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"SearchInput_form__SSK4O","inputSubmit":"SearchInput_inputSubmit__iTw2G","inputIcon":"SearchInput_inputIcon__NNp1D","searchInputContainer":"SearchInput_searchInputContainer__iYKqt","noResultsButton":"SearchInput_noResultsButton__CNbU_","noResultsButtonKeyword":"SearchInput_noResultsButtonKeyword__J6EXM"};

/***/ }),

/***/ 9793:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFilterToggleBar_container__S9_9K","filterBtn":"SearchFilterToggleBar_filterBtn__TgHdr","filterBtnIcon":"SearchFilterToggleBar_filterBtnIcon__VNglz","filterBtnText":"SearchFilterToggleBar_filterBtnText__XCyLR"};

/***/ }),

/***/ 4865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__zgAJj","header":"Home_header__6KCIB","inputMenuOpen":"Home_inputMenuOpen__jnEXa","sidebar":"Home_sidebar__moo8u","showSidebar":"Home_showSidebar__I0bGu Home_sidebar__moo8u","content":"Home_content__f1lUf","filterToggle":"Home_filterToggle__N96mk"};

/***/ }),

/***/ 4654:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [751,147,256,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);